/* Siora SkinInsights — bundled for Shopify (auto-generated, do not edit by hand). */
(function(){
"use strict";

/* ===== cv-analysis.js ===== */
/* ============================================================
   cv-analysis.js (v3) — accurate, inclusive in-browser skin CV.
   Upgrades:
     • landmark-precise regions (MediaPipe FaceMesh indices) w/ fraction fallback
     • Monk Skin Tone (10-shade, open/inclusive) + Fitzpatrick (ITA°)
     • tone-aware threshold calibration (fairer redness/pigmentation across tones)
     • gray-world white-balance + exposure normalization + skin gating
     • image-quality (sharpness/exposure) -> confidence + retake guidance
   100 = best/healthiest. Pure pixel math, no upload, no AI.
   ============================================================ */

// ---- colour helpers ----
function rgb2lab(r,g,b){ r/=255;g/=255;b/=255;
  r=r>0.04045?Math.pow((r+0.055)/1.055,2.4):r/12.92; g=g>0.04045?Math.pow((g+0.055)/1.055,2.4):g/12.92; b=b>0.04045?Math.pow((b+0.055)/1.055,2.4):b/12.92;
  let x=(r*0.4124+g*0.3576+b*0.1805)/0.95047,y=(r*0.2126+g*0.7152+b*0.0722),z=(r*0.0193+g*0.1192+b*0.9505)/1.08883;
  const f=t=>t>0.008856?Math.cbrt(t):(7.787*t+16/116); x=f(x);y=f(y);z=f(z);
  return [116*y-16,500*(x-y),200*(y-z)]; }
const scoreFrom=(v,lo,hi,inv=true)=>{ let t=(v-lo)/(hi-lo); t=Math.max(0,Math.min(1,t)); return Math.round((inv?1-t:t)*100); };
const isSkin=(r,g,b)=>{ const mx=Math.max(r,g,b),mn=Math.min(r,g,b),L=0.299*r+0.587*g+0.114*b; return L>38&&L<245&&r>g&&r>=b*0.82&&(mx-mn)<130; };

// ---- Monk Skin Tone anchors (open scale, sRGB) ----
const MONK=[[246,237,228],[243,231,219],[247,234,208],[234,218,186],[215,189,150],[160,126,86],[130,92,67],[96,65,52],[58,49,42],[41,36,32]];
const MONK_LABEL=["Very fair","Fair","Light","Light-medium","Medium","Tan","Deep-tan","Brown","Deep brown","Rich deep"];
function monkOf(r,g,b){ let best=0,bd=1e9; for(let i=0;i<MONK.length;i++){ const d=(r-MONK[i][0])**2+(g-MONK[i][1])**2+(b-MONK[i][2])**2; if(d<bd){bd=d;best=i;} } return best+1; }
function fitzOf(ita){ return ita>55?'I':ita>41?'II':ita>28?'III':ita>10?'IV':ita>-30?'V':'VI'; }

// ---- white balance + global stats over skin pixels ----
function globalStats(data,W,H){ let sr=0,sg=0,sb=0,n=0,sumL=0, allL=0,allN=0;
  for(let i=0;i<data.length;i+=16){ const r=data[i],g=data[i+1],b=data[i+2]; const lum=0.299*r+0.587*g+0.114*b; allL+=lum;allN++;
    if(data[i+3]<128||!isSkin(r,g,b))continue; sr+=r;sg+=g;sb+=b;sumL+=lum;n++; }
  const meanAll=allN?allL/allN:128;
  if(!n) return {gain:[1,1,1],meanL:128,skinFrac:0,skinRGB:[200,170,150],meanAll};
  const mr=sr/n,mg=sg/n,mb=sb/n,gray=(mr+mg+mb)/3;
  return { gain:[gray/mr,gray/mg,gray/mb], meanL:sumL/n, skinFrac:n/(data.length/16), skinRGB:[mr,mg,mb], meanAll }; }

// ---- region sampling (box in pixel space) ----
function sampleBox(data,W,H,cx,cy,half,G){ const x0=Math.max(0,cx-half|0),x1=Math.min(W,cx+half|0),y0=Math.max(0,cy-half|0),y1=Math.min(H,cy+half|0);
  let n=0,sumL=0,sumA=0,sumB=0,sumL2=0,spec=0;
  for(let y=y0;y<y1;y+=2)for(let x=x0;x<x1;x+=2){ const i=(y*W+x)*4; if(data[i+3]<128)continue;
    let r=Math.min(255,data[i]*G[0]),g=Math.min(255,data[i+1]*G[1]),b=Math.min(255,data[i+2]*G[2]); if(!isSkin(r,g,b))continue;
    const [L,A,B]=rgb2lab(r,g,b),mx=Math.max(r,g,b),mn=Math.min(r,g,b),sat=mx?(mx-mn)/mx:0,val=mx/255;
    if(val>0.80&&sat<0.20)spec++; n++;sumL+=L;sumA+=A;sumB+=B;sumL2+=L*L; }
  if(!n)return null; const mL=sumL/n; return {n,L:mL,a:sumA/n,b:sumB/n,std:Math.sqrt(Math.max(0,sumL2/n-mL*mL)),spec:spec/n}; }

function spotFrac(data,W,H,boxes,G){ let n=0,sum=0,vals=[];
  for(const[cx,cy,half] of boxes){ const x0=Math.max(0,cx-half|0),x1=Math.min(W,cx+half|0),y0=Math.max(0,cy-half|0),y1=Math.min(H,cy+half|0);
    for(let y=y0;y<y1;y+=2)for(let x=x0;x<x1;x+=2){ const i=(y*W+x)*4; if(data[i+3]<128)continue;
      let r=Math.min(255,data[i]*G[0]),g=Math.min(255,data[i+1]*G[1]),b=Math.min(255,data[i+2]*G[2]); if(!isSkin(r,g,b))continue;
      const L=0.299*r+0.587*g+0.114*b; sum+=L;vals.push(L);n++; } }
  if(n<20)return 0; const m=sum/n; let d=0; for(const L of vals)if(L<m-16)d++; return d/n; }

function edges(data,W,H,cx,cy,half){ const x0=Math.max(1,cx-half|0),x1=Math.min(W-1,cx+half|0),y0=Math.max(1,cy-half|0),y1=Math.min(H-1,cy+half|0);
  let n=0,e=0; for(let y=y0;y<y1;y+=2)for(let x=x0;x<x1;x+=2){ const i=(y*W+x)*4,id=((y+1)*W+x)*4,ir=(y*W+x+1)*4;
    const l=0.299*data[i]+0.587*data[i+1]+0.114*data[i+2],ld=0.299*data[id]+0.587*data[id+1]+0.114*data[id+2],lr=0.299*data[ir]+0.587*data[ir+1]+0.114*data[ir+2];
    if(Math.abs(l-ld)*1.4+Math.abs(l-lr)*0.4>13)e++; n++; } return n?e/n:0; }

// global sharpness (variance of gradient) for blur detection
function sharpness(data,W,H){ let n=0,s=0,s2=0; for(let y=2;y<H-2;y+=3)for(let x=2;x<W-2;x+=3){ const i=(y*W+x)*4,ir=(y*W+x+2)*4;
  const g=Math.abs((0.299*data[i]+0.587*data[i+1]+0.114*data[i+2])-(0.299*data[ir]+0.587*data[ir+1]+0.114*data[ir+2])); s+=g;s2+=g*g;n++; }
  const m=s/n; return Math.sqrt(Math.max(0,s2/n-m*m)); }

// ---- responsible lesion triage: largest compact dark-brown blob in central face ----
// NOT a diagnosis — only flags a distinct spot/mole to recommend a professional (ABCDE).
function lesionScan(data,W,H,G){
  const x0=W*0.20|0,x1=W*0.80|0,y0=H*0.30|0,y1=H*0.86|0,bs=6;
  const cols=Math.floor((x1-x0)/bs),rows=Math.floor((y1-y0)/bs);
  const grid=[],Ls=[];
  for(let r=0;r<rows;r++){ grid[r]=[]; for(let c=0;c<cols;c++){ let sl=0,n=0,brown=0;
    for(let y=y0+r*bs;y<y0+r*bs+bs;y+=2)for(let x=x0+c*bs;x<x0+c*bs+bs;x+=2){ const i=(y*W+x)*4; if(data[i+3]<128)continue;
      let R=Math.min(255,data[i]*G[0]),Gn=Math.min(255,data[i+1]*G[1]),B=Math.min(255,data[i+2]*G[2]); const L=0.299*R+0.587*Gn+0.114*B;
      sl+=L;n++; if(R>Gn&&Gn>=B*0.7&&L>35&&L<175)brown++; }
    const mean=n?sl/n:255; grid[r][c]={L:mean,brown:n>0&&brown/n>0.5}; if(n>0)Ls.push(mean); } }
  if(Ls.length<20) return {flag:false,area:0,contrast:0,frac:0};
  Ls.sort((a,b)=>a-b); const med=Ls[Ls.length>>1];
  const dark=grid.map(row=>row.map(cell=>cell.brown&&cell.L<med-26)); const seen=[];
  let best=0,bestC=0;
  for(let r=0;r<rows;r++)for(let c=0;c<cols;c++){ if(dark[r][c]&&!(seen[r]&&seen[r][c])){
    const st=[[r,c]]; let area=0,csum=0;
    while(st.length){ const[a,b]=st.pop(); if(a<0||b<0||a>=rows||b>=cols||!dark[a][b]||(seen[a]&&seen[a][b]))continue;
      (seen[a]=seen[a]||[])[b]=1; area++; csum+=med-grid[a][b].L; st.push([a+1,b],[a-1,b],[a,b+1],[a,b-1]); }
    if(area>best){best=area;bestC=csum/area;} } }
  const total=rows*cols;
  // mole-like: compact + distinct + high contrast, NOT huge (huge => beard/shadow)
  const flag=best>=2 && best<=Math.max(6,total*0.02) && bestC>30;
  return { flag, area:best, contrast:+bestC.toFixed(1), frac:+(best/total).toFixed(4) };
}

// ---- FaceMesh region centers (crop-normalized landmarks) ----
function centersFromLandmarks(lm,W,H){
  const P=i=>({x:lm[i].x*W,y:lm[i].y*H});
  let minx=1e9,maxx=-1e9; for(const p of lm){ minx=Math.min(minx,p.x*W); maxx=Math.max(maxx,p.x*W); }
  const fw=maxx-minx;
  const mid=(a,b)=>({x:(a.x+b.x)/2,y:(a.y+b.y)/2});
  return { fw,
    forehead: mid(P(10),P(9)), cheekL:P(50), cheekR:P(280),
    underEyeL:P(230), underEyeR:P(450), nose:P(195), chin:P(152),
    foreheadB:[P(67),P(10),P(297),P(9)] };
}

function analyzeImageData(imageData, landmarks){
  const { data, width:W, height:H } = imageData;
  const gs=globalStats(data,W,H), G=gs.gain;

  // regions: landmark-accurate if available, else fraction boxes
  let R;
  if(landmarks && landmarks.length>=468){
    const c=centersFromLandmarks(landmarks,W,H), h=Math.max(8,c.fw*0.07);
    const S=(p)=>sampleBox(data,W,H,p.x,p.y,h,G);
    R={ forehead:S(c.forehead), cheekL:S(c.cheekL), cheekR:S(c.cheekR), nose:S(c.nose), chin:S(c.chin),
        ueL:S(c.underEyeL), ueR:S(c.underEyeR), mode:'landmark',
        spotBoxes:[[c.cheekL.x,c.cheekL.y,h*1.6],[c.cheekR.x,c.cheekR.y,h*1.6],[c.forehead.x,c.forehead.y,h*1.6]],
        foreheadC:c.forehead, ueC:c.underEyeL, fh:h };
  } else {
    const B=(fx0,fy0,fx1,fy1)=>sampleBox(data,W,H,(fx0+fx1)/2*W,(fy0+fy1)/2*H,Math.min((fx1-fx0)*W,(fy1-fy0)*H)/2,G);
    R={ forehead:B(.30,.10,.70,.26), cheekL:B(.16,.45,.36,.70), cheekR:B(.64,.45,.84,.70), nose:B(.42,.34,.58,.58), chin:B(.40,.74,.60,.90),
        ueL:B(.20,.34,.40,.42), ueR:B(.60,.34,.80,.42), mode:'fraction',
        spotBoxes:[[.5*W,.55*H,.34*W],[ .5*W,.18*H,.4*W ]].map(b=>[b[0],b[1],b[2]/2]),
        foreheadC:{x:.5*W,y:.18*H}, ueC:{x:.3*W,y:.38*H}, fh:Math.min(W,H)*0.06 };
  }
  const tzone=[R.forehead,R.nose,R.chin].filter(Boolean), cheeks=[R.cheekL,R.cheekR].filter(Boolean),
        all=[R.forehead,R.cheekL,R.cheekR,R.nose,R.chin].filter(Boolean), ue=[R.ueL,R.ueR].filter(Boolean);
  const avg=(arr,k)=>arr.length?arr.reduce((s,r)=>s+r[k],0)/arr.length:0;

  // ---- skin tone (Monk + Fitzpatrick) from TRUE skin colour (not white-balanced) ----
  const sr=gs.skinRGB[0],sg=gs.skinRGB[1],sb=gs.skinRGB[2];
  const [sL,,sB]=rgb2lab(sr,sg,sb); const ita=Math.atan2(sL-50, Math.max(2,sB))*180/Math.PI;
  const monk=monkOf(sr,sg,sb), fitz=fitzOf(ita), toneHex='#'+[sr,sg,sb].map(v=>('0'+(Math.min(255,v)|0).toString(16)).slice(-2)).join('');
  const deep = monk>=7; // tone-aware calibration flag

  // ---- raw signals (LAB L* is perceptual 0..100 — used directly) ----
  const redA=avg(cheeks,'a'), specT=avg(tzone,'spec');
  const cheekLum=avg(cheeks,'L'), ueLum=avg(ue,'L'), ueDelta=cheekLum-ueLum;
  const texture=avg([R.nose,R.cheekL,R.cheekR].filter(Boolean),'std');
  const Ls=all.map(r=>r.L), mL=Ls.reduce((s,l)=>s+l,0)/Math.max(1,Ls.length);
  const toneStd=Math.sqrt(Ls.reduce((s,l)=>s+(l-mL)**2,0)/Math.max(1,Ls.length));
  const dull=100-mL, spots=spotFrac(data,W,H,R.spotBoxes,G);
  const linesE=edges(data,W,H,R.foreheadC.x,R.foreheadC.y,R.fh*1.6)+edges(data,W,H,R.ueC.x,R.ueC.y,R.fh*1.2)*0.5;
  const acneSig=Math.max(0,redA-(deep?9:6))*0.55+texture*0.22+spots*40*0.4;

  // tone-aware thresholds: deeper skin -> higher baseline a*, more PIH sensitivity
  const redHi = deep?26:22, pigHi = deep?0.17:0.20;

  const scores={
    redness:scoreFrom(redA,deep?9:6,redHi,true), oiliness:scoreFrom(specT,0.02,0.30,true),
    darkCircles:scoreFrom(ueDelta,2,16,true), pores:scoreFrom(texture,6,22,true),
    lines:scoreFrom(linesE,0.05,0.40,true), uniformity:scoreFrom(toneStd,3,16,true),
    hydration:scoreFrom(dull,30,62,true), pigmentation:scoreFrom(spots,0.03,pigHi,true),
    skinTone:scoreFrom(Math.abs(ita-45),5,60,true), acne:scoreFrom(acneSig,2,14,true)
  };

  // ---- quality + confidence ----
  const sharp=sharpness(data,W,H);
  const quality={ sharpness:+sharp.toFixed(1), exposure:+gs.meanAll.toFixed(1), skinFrac:+gs.skinFrac.toFixed(2),
    blurry:sharp<7 && gs.skinFrac>0.12, dark:gs.meanAll<55, bright:gs.meanAll>210, regions:all.length };
  let conf=0.45;
  if(R.mode==='landmark')conf+=0.18; if(gs.skinFrac>0.22)conf+=0.14; if(gs.meanL>60&&gs.meanL<205)conf+=0.12; if(!quality.blurry)conf+=0.08; if(all.length===5)conf+=0.06;
  conf=Math.min(0.98,conf);
  const retake = quality.blurry||quality.dark||quality.bright||gs.skinFrac<0.12;

  const safety = lesionScan(data,W,H,G);

  return {
    metrics:{ redA:+redA.toFixed(2),specT:+specT.toFixed(3),ueDelta:+ueDelta.toFixed(2),texture:+texture.toFixed(2),
      toneStd:+toneStd.toFixed(2),ita:+ita.toFixed(1),spots:+spots.toFixed(3),linesEdge:+linesE.toFixed(3),
      faceLum:+gs.meanL.toFixed(1),skinFrac:+gs.skinFrac.toFixed(2),mode:R.mode },
    scores, confidence:conf, retake,
    skinTone:{ monk, monkLabel:MONK_LABEL[monk-1], fitzpatrick:fitz, ita:+ita.toFixed(1), hex:toneHex },
    quality, safety
  };
}


/* ===== webgl-face.js ===== */
/* ============================================================
   webgl-face.js — the centrepiece.

   The model's photo is turned into a GPU particle cloud: every opaque pixel of the
   alpha-matted plate becomes a point, greyscale, pushed in Z by its own luminance so the
   face has real relief. Scroll scrubs it from scattered dust → assembled face → a scan
   plane sweeping down it → the ten concern regions lighting up.

   It is strictly optional. No WebGL, a failed context, reduced-motion, or a small screen
   → we bail and the DOM fallback (the flat face map) is used instead. Nothing on the page
   depends on this running.
   ============================================================ */

const VERT = `
  attribute vec3 aScatter;      // where the point sits in the "dust" state
  attribute vec3 aText;         // where the point sits when the face becomes the words
  attribute vec3 aColor;        // greyscale, sampled from the plate
  attribute float aDensity;     // luminance — drives point SIZE, which is what makes it
                                // read as a face rather than as noise
  attribute float aActive;      // 1.0 when this point is inside a highlighted region
  attribute float aSeed;        // per-point randomness
  attribute float aFade;        // 0 at the plate's cut edge, 1 in the body of the image

  uniform float uProgress;      // 0 = dust, 1 = face
  uniform float uMorph;         // 0 = face, 1 = the closing headline
  uniform float uScanY;         // world-Y of the scan plane (999 = off)
  uniform float uSize;
  uniform float uTime;
  uniform float uFocus;

  varying vec3  vColor;
  varying float vGlow;
  varying float vDof;
  varying float vFade;

  // cheap curl-ish drift so the skin is alive rather than frozen
  vec3 drift(vec3 p, float t) {
    return vec3(
      sin(p.y * 0.05 + t) * cos(p.z * 0.04 + t * 0.7),
      cos(p.x * 0.05 + t * 1.1) * sin(p.z * 0.03 + t),
      sin(p.x * 0.04 + t * 0.8) * cos(p.y * 0.05 + t * 0.9)
    );
  }

  void main() {
    // assemble, with a per-point delay so the face knits together rather than snapping
    float p = clamp((uProgress - aSeed * 0.3) / 0.7, 0.0, 1.0);
    p = p * p * (3.0 - 2.0 * p);
    vec3 pos = mix(aScatter, position, p);

    /* The closing beat: the face dissolves and reassembles into the words. Same buffer,
       same draw call — just a second target and a per-point stagger so it flows instead
       of snapping. Points with no letter to go to are pushed out of frame. */
    float m = clamp((uMorph - aSeed * 0.32) / 0.68, 0.0, 1.0);
    m = m * m * (3.0 - 2.0 * m);
    pos = mix(pos, aText, m);

    // ambient life: strong while it is dust, a whisper once assembled
    float t = uTime * 0.4;
    pos += drift(pos, t + aSeed * 6.28) * mix(9.0, 0.7, p);

    // the scan plane: points near it lift toward camera and flare
    float scan = 1.0 - smoothstep(0.0, 13.0, abs(pos.y - uScanY));
    pos.z += scan * 20.0;

    // a highlighted concern region lifts and brightens — GENTLY. aActive is a soft
    // elliptical falloff (0..1), not a hard mask, so regions read as a glow rather than
    // as a white rectangle stamped on her face.
    pos.z += aActive * 5.0;

    vGlow = clamp(scan * 1.0 + aActive * 0.45, 0.0, 1.0);
    vColor = aColor;

    /* The source plate is cropped at her chest, so the cloud would otherwise end on a hard
       horizontal edge — a guillotined shoulder. Dissolve the points into the black instead.
       Suspended while morphing into the headline, where every letter needs full weight. */
    vFade = mix(aFade, 1.0, m);

    vec4 mv = modelViewMatrix * vec4(pos, 1.0);

    // fake depth-of-field: points away from the focal plane soften
    vDof = clamp(abs(uFocus + mv.z) / 130.0, 0.0, 1.0);

    // SIZE BY DENSITY — bright pixels (eyes, lips, highlights) get fat points, shadows get
    // fine ones. This is what resolves the cloud into a recognisable face.
    // while morphing, every point carries equal weight (letters need even density)
    float size = mix(mix(0.35, 1.9, aDensity), 1.15, m);
    size *= (1.0 + vGlow * 1.05);
    size *= mix(1.0, 0.55, vDof);
    size *= mix(0.55, 1.0, p);
    size *= mix(0.35, 1.0, vFade);

    gl_PointSize = uSize * size * (300.0 / max(-mv.z, 1.0));
    gl_Position = projectionMatrix * mv;
  }
`;

const FRAG = `
  precision mediump float;
  uniform float uOpacity;
  varying vec3  vColor;
  varying float vGlow;
  varying float vDof;
  varying float vFade;

  void main() {
    vec2 d = gl_PointCoord - 0.5;
    float r = dot(d, d);
    if (r > 0.25) discard;
    // out-of-focus points get a softer edge — cheap bokeh
    float a = smoothstep(0.25, mix(0.02, 0.2, vDof), r);

    vec3 c = mix(vColor, vec3(1.0), clamp(vGlow * 0.85, 0.0, 1.0));
    gl_FragColor = vec4(c, a * uOpacity * (0.5 + vGlow * 0.45) * mix(1.0, 0.5, vDof) * vFade);
  }
`;

/* Region boxes in % of the plate — the analyser's real regions from concerns.json.
   Exported and imported by landing.js: this is the ONE place they are defined. Keeping a
   second copy there meant a new plate had to be measured into several files at once, and
   any file that got missed pointed the highlights at her hair. */
/* Tuned to si-face-alpha.png (540×675, 2026-07-27 portrait) — the face sits lower in
   frame than the old plate because this one keeps the crown, hair and shoulders. */
const REGIONS = {
  forehead:      { l: 33, t: 16, w: 34, h: 11 },
  underEyeLeft:  { l: 29, t: 42, w: 13, h: 5 },
  underEyeRight: { l: 57, t: 42, w: 13, h: 5 },
  noseBridge:    { l: 45, t: 32, w: 10, h: 22 },
  cheekLeft:     { l: 24, t: 46, w: 14, h: 12 },
  cheekRight:    { l: 62, t: 46, w: 14, h: 12 },
  chin:          { l: 43, t: 69, w: 14, h: 8 },
};
const REGION_KEYS = Object.keys(REGIONS);

function createFaceField({ canvas, src, onReady, mobileZ, phoneSize }) {
  const THREE = window.THREE;
  if (!THREE || !canvas) return null;

  // hard bail-outs — this is a bonus, never a dependency
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
  try {
    const probe = document.createElement('canvas');
    if (!(probe.getContext('webgl') || probe.getContext('experimental-webgl'))) return null;
  } catch (e) { return null; }

  /* Phones GET the particle field too — the same face on mobile as on desktop — but tuned so
     it stays smooth. A full-screen additive point cloud is fill-rate bound, and a phone runs
     at DPR 3 (~9x the pixels of a desktop), so we cut two knobs on small screens: far fewer
     points, and a hard DPR cap of 1.3. Only a field that is off-screen pauses (the observer),
     and there is never more than one running at a time. Reduced-motion and no-WebGL still fall
     back to the flat map above/below. */
  const isPhone = window.innerWidth < 760 || (navigator.maxTouchPoints > 0 && window.innerWidth < 900);

  const small = isPhone;
  const cores = navigator.hardwareConcurrency || 4;
  const TARGET = isPhone ? 16000 : (cores <= 4 ? 32000 : 46000);
  const MAX_DPR = isPhone ? 1.3 : 1.6;

  let renderer, scene, camera, points, geo, mat, raf = 0, running = false;
  const state = { progress: 0, scanY: 999, opacity: 0, morph: 0, tilt: { x: 0, y: 0 } };
  const OFFSET_Y = 0;
  let textAttr = null;                            // the "becomes the headline" target
  let regionOf = null;                            // Float32Array: region index per point
  let regionW  = null;                            // Float32Array: soft 0..1 falloff per point
  let activeAttr = null;

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => { try { build(img); } catch (e) { destroy(); } };
  img.onerror = () => destroy();
  img.src = src;

  function build(image) {
    const W = image.naturalWidth, H = image.naturalHeight;
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(image, 0, 0);
    const px = ctx.getImageData(0, 0, W, H).data;

    // collect every opaque pixel, then decimate evenly to the target count
    const all = [];
    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        const i = (y * W + x) * 4;
        if (px[i + 3] > 128) all.push(i);
      }
    }
    if (!all.length) return destroy();
    const stride = Math.max(1, Math.floor(all.length / TARGET));
    const count = Math.floor(all.length / stride);

    const PLANE_H = 200;                                   // world height of the plate
    const PLANE_W = PLANE_H * (W / H);

    const pos     = new Float32Array(count * 3);
    const scatter = new Float32Array(count * 3);
    const col     = new Float32Array(count * 3);
    const seed    = new Float32Array(count);
    const dens    = new Float32Array(count);
    const fade    = new Float32Array(count);
    const active  = new Float32Array(count);
    regionOf      = new Float32Array(count);
    regionW       = new Float32Array(count);

    for (let n = 0; n < count; n++) {
      // Pick a RANDOM pixel within each stride bucket — not the fixed n*stride. Even-stride
      // sampling over the raster is exactly what printed those moiré chevrons across the face;
      // a random pick per bucket + sub-pixel jitter below dissolves the grid into a clean cloud.
      const i = all[Math.min(all.length - 1, n * stride + (Math.random() * stride | 0))];
      const p = i / 4;
      const x = p % W, y = (p / W) | 0;
      const r = px[i] / 255, g = px[i + 1] / 255, b = px[i + 2] / 255;
      const lum = 0.299 * r + 0.587 * g + 0.114 * b;

      // plate space → world space, centred (sub-pixel jitter breaks the source pixel grid)
      const u = (x + (Math.random() - 0.5)) / W, v = (y + (Math.random() - 0.5)) / H;
      pos[n * 3]     = (u - 0.5) * PLANE_W;
      pos[n * 3 + 1] = -(v - 0.5) * PLANE_H;
      pos[n * 3 + 2] = (lum - 0.5) * 26;                   // luminance becomes relief

      // dust state: a loose shell around the face
      const a = Math.random() * Math.PI * 2;
      const rad = 90 + Math.random() * 190;
      scatter[n * 3]     = Math.cos(a) * rad * 1.15;
      scatter[n * 3 + 1] = (Math.random() - 0.5) * 420;
      scatter[n * 3 + 2] = (Math.random() - 0.5) * 300 - 40;

      // greyscale — the brand is black and white
      const tone = 0.32 + lum * 0.68;
      col[n * 3] = col[n * 3 + 1] = col[n * 3 + 2] = tone;

      seed[n] = Math.random();
      dens[n] = Math.pow(lum, 0.75);          // slight lift so mid-tones still carry mass
      /* The new plate is a CLEAN matte — full head, neck and shoulders on transparency, no hard
         crops — so the heavy edge-dissolves the old cropped photo needed are gone. Keep the neck
         and shoulders fully; only feather the extreme bottom edge and the very crown into black
         so nothing ends on a hard horizontal line. */
      const botStart = 0.93;                              // keep neck + shoulders; soften only the last sliver
      let f = v <= botStart ? 1 : Math.max(0, 1 - (v - botStart) / (1 - botStart));
      f = f * f;
      const topBand = 0.05;                               // gentle crown feather (plate has headroom now)
      let topF = v >= topBand ? 1 : v / topBand;
      topF = topF * topF * (3 - 2 * topF);
      fade[n] = f * topF;

      /* Which concern region this point belongs to, and HOW strongly. An elliptical
         distance with a feathered edge — a hard rectangular in/out test is what made the
         highlight look like a white sticker rather than a glow. */
      let reg = 0, best = 0;
      const uu = u * 100, vv = v * 100;
      for (let k = 0; k < REGION_KEYS.length; k++) {
        const R = REGIONS[REGION_KEYS[k]];
        const cx = R.l + R.w / 2, cy = R.t + R.h / 2;
        const dx = (uu - cx) / (R.w / 2), dy = (vv - cy) / (R.h / 2);
        const d = Math.sqrt(dx * dx + dy * dy);            // 0 at centre, 1 at the edge
        const w = 1 - Math.min(1, Math.max(0, (d - 0.35) / 0.75));   // feathered
        if (w > best) { best = w; reg = k + 1; }
      }
      regionOf[n] = reg;
      regionW[n] = best * best;                            // ease the falloff
    }

    geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    geo.setAttribute('aScatter', new THREE.BufferAttribute(scatter, 3));
    geo.setAttribute('aColor',   new THREE.BufferAttribute(col, 3));
    geo.setAttribute('aSeed',    new THREE.BufferAttribute(seed, 1));
    textAttr = new THREE.BufferAttribute(new Float32Array(count * 3), 3);
    geo.setAttribute('aText', textAttr);
    geo.setAttribute('aDensity', new THREE.BufferAttribute(dens, 1));
    geo.setAttribute('aFade',    new THREE.BufferAttribute(fade, 1));
    activeAttr = new THREE.BufferAttribute(active, 1);
    geo.setAttribute('aActive', activeAttr);

    mat = new THREE.ShaderMaterial({
      vertexShader: VERT,
      fragmentShader: FRAG,
      uniforms: {
        uProgress: { value: 0 },
        uMorph:    { value: 0 },
        uScanY:    { value: 999 },
        uSize:     { value: isPhone ? (phoneSize || 4.4) : 3.1 },   // the scan passes a smaller phoneSize (its camera is close, so points are already big — keeps bright skin from blowing out to white); the closing keeps the fatter default
        uTime:     { value: 0 },
        uFocus:    { value: 300 },
        uOpacity:  { value: 0 },
      },
      transparent: true,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
    });

    scene = new THREE.Scene();
    points = new THREE.Points(geo, mat);
    points.position.y = OFFSET_Y;      // phones: copy on top, face below it
    scene.add(points);

    camera = new THREE.PerspectiveCamera(42, 1, 1, 2000);
    camera.position.set(0, 0, 560);

    renderer = new THREE.WebGLRenderer({ canvas, antialias: false, alpha: true, powerPreference: 'high-performance' });
    renderer.setClearColor(0x000000, 0);
    resize();
    window.addEventListener('resize', resize);
    /* The canvas is measured with getBoundingClientRect(), but build() runs on image-load —
       which can beat layout/sticky settling, leaving a stale aspect and a projection that
       renders the scene off-centre. Watch the element instead of trusting one measurement. */
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    requestAnimationFrame(resize);

    running = true;
    loop();
    if (onReady) onReady();
  }

  function resize() {
    if (!renderer || !camera) return;
    const r = canvas.getBoundingClientRect();
    const w = Math.max(1, r.width), h = Math.max(1, r.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, MAX_DPR));
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    // The scan face now lives in its OWN bounded canvas (a lower band on phones), so it just
    // needs to sit centred and whole inside that box — `mobileZ` frames the full plate to the
    // box with margin (the cropped crown then dissolves into black instead of being severed by
    // the viewport). The closing field passes no mobileZ, so it keeps its text-sized framing.
    const phone = w < 760;
    camera.position.z = phone && mobileZ ? mobileZ : 570 / Math.min(1.25, Math.max(0.7, camera.aspect));
    if (points) points.position.y = OFFSET_Y;
    camera.updateProjectionMatrix();
    mat.uniforms.uFocus.value = camera.position.z;
    // Draw straight away. During the phase-3 reframe the canvas HEIGHT animates via CSS, so this
    // fires every frame — and setSize() clears the buffer, so without an immediate re-render the
    // paint would show an empty frame and the whole thing would strobe. Rendering here fills the
    // new buffer in the same frame → the resize reads as one smooth, continuous zoom.
    if (running) renderer.render(scene, camera);
  }

  const clock = { t0: performance.now() };
  function loop() {
    if (!running) return;
    raf = requestAnimationFrame(loop);
    const t = (performance.now() - clock.t0) / 1000;
    mat.uniforms.uTime.value = t;
    mat.uniforms.uProgress.value += (state.progress - mat.uniforms.uProgress.value) * 0.08;
    mat.uniforms.uMorph.value += (state.morph - mat.uniforms.uMorph.value) * 0.09;
    mat.uniforms.uScanY.value = state.scanY;
    mat.uniforms.uOpacity.value += (state.opacity - mat.uniforms.uOpacity.value) * 0.07;

    // gentle parallax toward the cursor
    points.rotation.y += (state.tilt.x * 0.22 - points.rotation.y) * 0.05;
    points.rotation.x += (state.tilt.y * 0.16 - points.rotation.x) * 0.05;

    renderer.render(scene, camera);
  }

  function destroy() {
    running = false;
    cancelAnimationFrame(raf);
    window.removeEventListener('resize', resize);
    try { geo && geo.dispose(); mat && mat.dispose(); renderer && renderer.dispose(); } catch (e) {}
  }

  return {
    /* 0 = dust, 1 = fully assembled face */
    setProgress(v) { state.progress = Math.max(0, Math.min(1, v)); },
    /* 0..1 sweeps the scan plane top → bottom; null switches it off */
    setScan(v) { state.scanY = v == null ? 999 : (0.5 - v) * 220; },
    setOpacity(v) { state.opacity = Math.max(0, Math.min(1, v)); },
    setTilt(x, y) { state.tilt.x = x; state.tilt.y = y; },
    /* Rasterise a line (or two) of text and use its pixels as the particle target. */
    setTextTarget(lines, opts) {
      if (!textAttr || !geo) return;
      const o = opts || {};
      const CW = 1024, CH = 512;
      const c = document.createElement('canvas');
      c.width = CW; c.height = CH;
      const x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#000'; x.fillRect(0, 0, CW, CH);
      x.fillStyle = '#fff';
      x.textAlign = 'center'; x.textBaseline = 'middle';
      const size = o.size || 150;
      x.font = '800 ' + size + 'px ' + (o.font || '"Assistant", system-ui, sans-serif');
      const arr = [].concat(lines);
      const lh = size * 1.02;
      arr.forEach((t, i) => x.fillText(t, CW / 2, CH / 2 + (i - (arr.length - 1) / 2) * lh));

      const px = x.getImageData(0, 0, CW, CH).data;
      const hits = [];
      for (let y = 0; y < CH; y += 2) {
        for (let xx = 0; xx < CW; xx += 2) {
          if (px[(y * CW + xx) * 4] > 128) hits.push([xx, y]);
        }
      }
      const t = textAttr.array;
      const n = t.length / 3;
      const SPAN = o.width || 300;                       // world width of the headline
      const SY = SPAN * (CH / CW);
      for (let i = 0; i < n; i++) {
        if (!hits.length) { t[i*3] = 0; t[i*3+1] = 0; t[i*3+2] = -900; continue; }
        const h = hits[(Math.random() * hits.length) | 0];
        // jitter so it reads as particles, not a dot-matrix print
        t[i*3]     = ((h[0] / CW) - 0.5) * SPAN + (Math.random() - 0.5) * 1.6;
        t[i*3 + 1] = -(((h[1] / CH) - 0.5) * SY) + (o.oy || 0) + (Math.random() - 0.5) * 1.6;
        t[i*3 + 2] = (Math.random() - 0.5) * 8;
      }
      textAttr.needsUpdate = true;
    },
    /* 0 = the face, 1 = the words */
    setMorph(v) { state.morph = Math.max(0, Math.min(1, v)); },

    /* light up the regions a concern is actually read from */
    setRegions(keys) {
      if (!activeAttr || !regionOf) return;
      const want = new Set((keys || []).map(k => REGION_KEYS.indexOf(k) + 1));
      const arr = activeAttr.array;
      for (let i = 0; i < arr.length; i++) arr[i] = want.has(regionOf[i]) ? regionW[i] : 0;
      activeAttr.needsUpdate = true;
    },
    pause() { if (running) { running = false; cancelAnimationFrame(raf); } },
    resume() { if (!running && renderer) { running = true; loop(); } },
    destroy,
  };
}


/* ===== live-proof.js ===== */
/* ============================================================
   live-proof.js — the privacy section, proved instead of claimed.

   "Your photo never leaves your device" is the single most important thing this page says,
   and a card that merely asserts it is worth nothing. So we run the analyser's REAL maths
   (rgb2lab / isSkin, imported straight from cv-analysis.js — not a lookalike) on a face,
   in the visitor's own browser, live — and simultaneously count every network request the
   page makes while it does so.

   The answer is zero, and we show the count. That is a claim the visitor can verify in
   their own devtools, which is the only kind of privacy claim worth making.
   ============================================================ */


/* ---------------- the outbound ledger ----------------
   Wrap every channel a page can use to send data out, count what goes through, and pass it
   straight along. This is a PASSTHROUGH — it never blocks a request, so the real cart /
   lead / AI calls later in the funnel behave exactly as before. It only counts.

   Installed as early as possible so the figure covers the whole page, not a convenient
   window. If it ever reads anything but zero on this page, the claim is false and the
   visitor will see that. */
const ledger = { posts: 0, bytes: 0, installed: false };

function bodySize(body) {
  try {
    if (!body) return 0;
    if (typeof body === 'string') return new Blob([body]).size;
    if (body instanceof Blob) return body.size;
    if (body instanceof ArrayBuffer) return body.byteLength;
    if (body instanceof FormData) { let n = 0; for (const [k, v] of body) n += (v && v.size) || String(v).length; return n; }
    if (body instanceof URLSearchParams) return new Blob([body.toString()]).size;
  } catch (e) {}
  return 0;
}

function installLedger() {
  if (ledger.installed) return ledger;
  ledger.installed = true;

  const of = window.fetch;
  if (of) {
    window.fetch = function (input, init) {
      const m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (m !== 'GET' && m !== 'HEAD') { ledger.posts++; ledger.bytes += bodySize(init && init.body); }
      return of.apply(this, arguments);
    };
  }
  const os = XMLHttpRequest.prototype.send;
  const oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method) { this.__m = String(method || '').toUpperCase(); return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__m && this.__m !== 'GET' && this.__m !== 'HEAD') { ledger.posts++; ledger.bytes += bodySize(body); }
    return os.apply(this, arguments);
  };
  const ob = navigator.sendBeacon && navigator.sendBeacon.bind(navigator);
  if (ob) navigator.sendBeacon = function (url, data) { ledger.posts++; ledger.bytes += bodySize(data); return ob(url, data); };

  return ledger;
}

function readLedger() { return { posts: ledger.posts, bytes: ledger.bytes }; }


/* the analyser's real face regions, as % of the plate (same numbers as the scan section) */
const R = {
  forehead:  { l: 33, t: 11, w: 36, h: 12 },
  cheekL:    { l: 25, t: 47, w: 14, h: 12 },
  cheekR:    { l: 65, t: 47, w: 14, h: 12 },
  nose:      { l: 46, t: 33, w: 11, h: 21 },
  underEyeL: { l: 31, t: 43, w: 13, h: 5 },
  underEyeR: { l: 61, t: 43, w: 13, h: 5 },
};

/* sample one region: mean L*, a*, b*, luminance spread, and specular (shine) fraction */
function sample(px, W, H, box) {
  const x0 = (box.l / 100) * W | 0, x1 = ((box.l + box.w) / 100) * W | 0;
  const y0 = (box.t / 100) * H | 0, y1 = ((box.t + box.h) / 100) * H | 0;
  let n = 0, sL = 0, sA = 0, sB = 0, sL2 = 0, spec = 0;
  for (let y = y0; y < y1; y++) {
    for (let x = x0; x < x1; x++) {
      const i = (y * W + x) * 4;
      if (px[i + 3] < 128) continue;
      const r = px[i], g = px[i + 1], b = px[i + 2];
      if (!isSkin(r, g, b)) continue;
      const [L, A, B] = rgb2lab(r, g, b);
      const mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      const sat = mx ? (mx - mn) / mx : 0, val = mx / 255;
      if (val > 0.80 && sat < 0.20) spec++;         // specular highlight = shine
      n++; sL += L; sA += A; sB += B; sL2 += L * L;
    }
  }
  if (!n) return null;
  const mL = sL / n;
  return {
    n, L: mL, a: sA / n, b: sB / n,
    std: Math.sqrt(Math.max(0, sL2 / n - mL * mL)),
    spec: spec / n,
  };
}

/* Run the measurements, and count every network request the page makes while doing it. */
function runLiveProof({ src, onTick, onDone }) {
  const img = new Image();
  img.onerror = () => onDone && onDone(null);
  img.onload = () => {
    /* Start the window only AFTER the photo has downloaded. The download is a page asset,
       not part of the measurement — counting it would make the "0 requests" figure a lie.
       What we are proving is that MEASURING a face sends nothing.

       We snapshot the outbound ledger RIGHT HERE and again after the synchronous computation
       below. The claim is precise — "how many requests did the ANALYSIS make" — so the count
       must be scoped to the analysis, not to the whole page. On a real storefront the page is
       also running Shopify analytics, a Meta pixel, etc.; a page-wide tally would attribute
       THEIR traffic to us and read as 15 requests when the analysis itself sent nothing. The
       computation between the two snapshots is fully synchronous and makes no network call, so
       this delta is a true, verifiable zero on any store. */
    const t0 = performance.now();
    const before = performance.getEntriesByType('resource').length;
    const ledgerBefore = readLedger();

    const W = img.naturalWidth, H = img.naturalHeight;
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    const px = ctx.getImageData(0, 0, W, H).data;   // pixels never leave this function

    const fh = sample(px, W, H, R.forehead);
    const cl = sample(px, W, H, R.cheekL);
    const cr = sample(px, W, H, R.cheekR);
    const no = sample(px, W, H, R.nose);
    const ul = sample(px, W, H, R.underEyeL);
    const ur = sample(px, W, H, R.underEyeR);
    if (!cl || !cr || !fh) { onDone && onDone(null); return; }

    const cheekL = (cl.L + cr.L) / 2;
    const cheekA = (cl.a + cr.a) / 2;
    const cheekB = (cl.b + cr.b) / 2;
    const tzoneSpec = ((fh.spec + (no ? no.spec : fh.spec)) / 2) * 100;
    const texture = (cl.std + cr.std) / 2;
    const underEye = ul && ur ? cheekL - (ul.L + ur.L) / 2 : 0;
    const ita = Math.atan2(cheekL - 50, Math.max(2, cheekB)) * 180 / Math.PI;

    // ...and after. Anything > 0 would mean the "measurement" phoned home.
    const after = performance.getEntriesByType('resource').length;
    const ledgerAfter = readLedger();
    const reqDuringAnalysis   = Math.max(0, ledgerAfter.posts - ledgerBefore.posts);
    const bytesDuringAnalysis = Math.max(0, ledgerAfter.bytes - ledgerBefore.bytes);

    const metrics = [
      { k: 'Redness',      sub: 'CIE-LAB a* · cheeks',      v: cheekA,    unit: '',   dp: 1 },
      { k: 'Shine',        sub: 'specular pixels · T-zone', v: tzoneSpec, unit: '%',  dp: 1 },
      { k: 'Texture',      sub: 'luminance σ · cheeks',     v: texture,   unit: '',   dp: 1 },
      { k: 'Under-eye Δ',  sub: 'cheek L* − under-eye L*',  v: underEye,  unit: '',   dp: 1 },
      { k: 'Skin tone',    sub: 'ITA° · Fitzpatrick ' + fitzOf(ita), v: ita, unit: '°', dp: 0 },
    ];

    onDone && onDone({
      metrics,
      pixelsRead: (cl.n + cr.n + fh.n + (no ? no.n : 0) + (ul ? ul.n : 0) + (ur ? ur.n : 0)),
      ms: Math.max(1, Math.round(performance.now() - t0)),
      requestsDuringAnalysis: Math.max(0, after - before),   // resources that resolved mid-analysis
      reqDuringAnalysis,                                      // requests the analysis itself made
      bytesDuringAnalysis,                                    // bytes the analysis itself uploaded
    });
  };

  if (onTick) onTick();
  img.src = src;   // the ONLY fetch here, and it is a download, not an upload
}


/* ===== skin-radar.js ===== */
/* ============================================================
   skin-radar.js — the results "skin map" as an interactive 3D radar.

   three.js draws the web: faint concentric rings + axes, a translucent data polygon lifted
   in Z by each score, and a glowing grade-coloured node at every vertex. GSAP springs the
   whole shape out of the centre on reveal and pops each node in. The pointer tilts the plane
   (holographic parallax); hovering a node — or its HTML label — blooms that node, draws its
   spoke bright, and prints a live "concern · score · grade" readout beneath.

   The labels are real HTML, positioned by angle and anchored away from centre, so long words
   like "Pigmentation" render crisp and never clip the canvas — the bug that started this.

   Strictly progressive: no WebGL / no three.js / reduced-motion → a clean 2D canvas radar
   with the same data. Nothing here is load-bearing for the rest of the results.
   ============================================================ */

const GRADE_HEX = { A:'#1f9d61', B:'#5bbf6a', C:'#d6a31e', D:'#d68a1e', E:'#c0392b' };
const hexInt = h => parseInt(h.slice(1), 16);

function createSkinRadar(container, concerns) {
  if (!container || !concerns || !concerns.length) return;
  const THREE = window.THREE, gsap = window.gsap;
  const N = concerns.length;
  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  container.classList.add('si-radar3d');
  container.innerHTML =
    '<div class="si-radar3d__panel">' +
      '<div class="si-radar3d__stage"><canvas class="si-radar3d__gl" aria-hidden="true"></canvas></div>' +
      '<div class="si-radar3d__labels"></div>' +
    '</div>' +
    '<p class="si-radar3d__read" aria-live="polite"><b></b><span></span></p>';

  const stage  = container.querySelector('.si-radar3d__stage');
  const canvas = container.querySelector('.si-radar3d__gl');
  const labsEl = container.querySelector('.si-radar3d__labels');
  const readEl = container.querySelector('.si-radar3d__read');

  /* ---- HTML labels: crisp, full text, centred on the perimeter so long words never clip.
     The web fills the inner ~64% of the panel; labels ride a 40% radius, clear of it. ---- */
  const labels = concerns.map((c, i) => {
    const a = Math.PI / 2 - (i / N) * Math.PI * 2;           // first item at top, clockwise
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'si-radar3d__lab';
    b.innerHTML = '<i style="background:' + GRADE_HEX[c.grade] + '"></i><span>' + escR(c.label) + '</span>';
    b.style.left = (50 + Math.cos(a) * 40) + '%';
    b.style.top  = (50 - Math.sin(a) * 40) + '%';            // screen Y is down → flip
    b.dataset.i = i;
    labsEl.appendChild(b);
    return b;
  });

  const setRead = (i) => {
    const b = readEl.querySelector('b'), sp = readEl.querySelector('span');
    if (i == null) { b.textContent = ''; sp.textContent = 'Hover a signal to inspect'; return; }
    const c = concerns[i];
    b.textContent = c.label;
    sp.innerHTML = ' · score ' + Math.round(c.score) +
      ' · grade <b style="color:' + GRADE_HEX[c.grade] + '">' + c.grade + '</b>';
  };
  setRead(null);

  /* ---- 2D fallback: no three.js / reduced motion ---- */
  if (!THREE || reduced) { draw2D(canvas, concerns, N); wireLabels2D(); return; }

  /* ============ three.js scene ============ */
  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  } catch (e) { draw2D(canvas, concerns, N); wireLabels2D(); return; }
  renderer.setClearColor(0x000000, 0);

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(36, 1, 0.1, 100);
  camera.position.set(0, 0, 36);

  const R = 10, DEPTH = 2.6;
  const angle = i => Math.PI / 2 - (i / N) * Math.PI * 2;   // first item at top, clockwise (matches labels)
  const vert = i => { const a = angle(i), r = R * clamp01(concerns[i].score / 100); return new THREE.Vector3(Math.cos(a) * r, Math.sin(a) * r, clamp01(concerns[i].score / 100) * DEPTH); };

  const root = new THREE.Group(); scene.add(root);

  // rings
  const ringMats = [];
  for (let g = 1; g <= 4; g++) {
    const pts = [];
    for (let i = 0; i <= N; i++) { const a = angle(i), r = R * g / 4; pts.push(new THREE.Vector3(Math.cos(a) * r, Math.sin(a) * r, 0)); }
    const m = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 });
    ringMats.push(m);
    root.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(pts), m));
  }
  // axes (one line each, so we can brighten individually on hover)
  const axisMats = [];
  for (let i = 0; i < N; i++) {
    const a = angle(i);
    const m = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 });
    axisMats.push(m);
    root.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(0, 0, 0), new THREE.Vector3(Math.cos(a) * R, Math.sin(a) * R, 0)]), m));
  }

  // data sub-group (springs out of the centre)
  const data = new THREE.Group(); root.add(data);
  const verts = concerns.map((_, i) => vert(i));

  // filled polygon (triangle fan from centre)
  const fillPos = new Float32Array((N + 1) * 3);
  for (let i = 0; i < N; i++) { fillPos[(i + 1) * 3] = verts[i].x; fillPos[(i + 1) * 3 + 1] = verts[i].y; fillPos[(i + 1) * 3 + 2] = verts[i].z; }
  const fillIdx = [];
  for (let i = 0; i < N; i++) fillIdx.push(0, i + 1, ((i + 1) % N) + 1);
  const fillGeo = new THREE.BufferGeometry();
  fillGeo.setAttribute('position', new THREE.BufferAttribute(fillPos, 3));
  fillGeo.setIndex(fillIdx);
  const fillMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.12, side: THREE.DoubleSide, depthWrite: false });
  data.add(new THREE.Mesh(fillGeo, fillMat));

  // outline
  const outMat = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.9 });
  data.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([...verts, verts[0]]), outMat));

  // glowing grade-coloured nodes (additive sprites)
  const glowTex = makeGlow(THREE);
  const nodes = verts.map((v, i) => {
    const mat = new THREE.SpriteMaterial({ map: glowTex, color: hexInt(GRADE_HEX[concerns[i].grade]), transparent: true, blending: THREE.AdditiveBlending, depthWrite: false, depthTest: false });
    const s = new THREE.Sprite(mat); s.position.copy(v); s.scale.setScalar(3.0); s.userData = { i, base: 3.0 };
    data.add(s); return s;
  });
  // solid core dot on top so the node reads as a point, not just a haze
  const coreTex = makeDisc(THREE);
  const cores = verts.map((v, i) => {
    const mat = new THREE.SpriteMaterial({ map: coreTex, color: hexInt(GRADE_HEX[concerns[i].grade]), transparent: true, depthWrite: false, depthTest: false });
    const s = new THREE.Sprite(mat); s.position.copy(v); s.scale.setScalar(0.9); s.userData = { base: 0.9 };
    data.add(s); return s;
  });

  /* ---- entrance (GSAP) ---- */
  data.scale.setScalar(0.0001);
  outMat.opacity = 0; fillMat.opacity = 0;
  ringMats.forEach(m => gsap.to(m, { opacity: 0.09, duration: 0.7, delay: 0.05, ease: 'power2.out' }));
  axisMats.forEach((m, i) => gsap.to(m, { opacity: 0.07, duration: 0.5, delay: 0.1 + i * 0.03, ease: 'power2.out' }));
  gsap.to(data.scale, { x: 1, y: 1, z: 1, duration: 1.15, delay: 0.25, ease: 'back.out(1.5)' });
  gsap.to(fillMat, { opacity: 0.12, duration: 0.9, delay: 0.4 });
  gsap.to(outMat, { opacity: 0.9, duration: 0.9, delay: 0.4 });
  nodes.forEach((s, i) => { s.scale.setScalar(0.0001); gsap.to(s.scale, { x: 3, y: 3, z: 3, duration: 0.6, delay: 0.55 + i * 0.05, ease: 'back.out(2.2)' }); });
  cores.forEach((s, i) => { s.scale.setScalar(0.0001); gsap.to(s.scale, { x: 0.9, y: 0.9, z: 0.9, duration: 0.6, delay: 0.6 + i * 0.05, ease: 'back.out(2.2)' }); });

  /* ---- pointer parallax tilt ---- */
  const target = { x: 0.14, y: 0 }, cur = { x: 0.14, y: 0 };
  let hovering = -1, idle = 0;
  stage.addEventListener('pointermove', e => {
    const r = stage.getBoundingClientRect();
    target.y = ((e.clientX - r.left) / r.width - 0.5) * 0.5;
    target.x = 0.14 + ((e.clientY - r.top) / r.height - 0.5) * -0.4;
    idle = 0;
  });
  stage.addEventListener('pointerleave', () => { target.x = 0.14; target.y = 0; });

  /* ---- hover: labels + raycast the nodes ---- */
  const ray = new THREE.Raycaster(); ray.params.Sprite = { threshold: 0.1 };
  const ndc = new THREE.Vector2();
  const hover = (raw) => {
    const i = (raw == null || raw < 0) ? null : raw;         // -1 / null both mean "nothing hovered"
    if (i === hovering) return;
    hovering = i;
    setRead(i);
    labels.forEach((l, k) => l.classList.toggle('on', k === i));
    nodes.forEach((s, k) => gsap.to(s.scale, { x: k === i ? 4.6 : 3, y: k === i ? 4.6 : 3, duration: 0.3, ease: 'power2.out' }));
    axisMats.forEach((m, k) => gsap.to(m, { opacity: k === i ? 0.5 : 0.07, duration: 0.3 }));
    if (i != null) gsap.fromTo(outMat, { opacity: 0.9 }, { opacity: 1, duration: 0.2 });
  };
  labels.forEach(l => {
    const i = +l.dataset.i;
    l.addEventListener('pointerenter', () => hover(i));
    l.addEventListener('focus', () => hover(i));
    l.addEventListener('pointerleave', () => hover(-1));
    l.addEventListener('blur', () => hover(-1));
  });
  stage.addEventListener('pointermove', e => {
    const r = stage.getBoundingClientRect();
    ndc.x = ((e.clientX - r.left) / r.width) * 2 - 1;
    ndc.y = -((e.clientY - r.top) / r.height) * 2 + 1;
    ray.setFromCamera(ndc, camera);
    const hit = ray.intersectObjects(nodes, false)[0];
    if (hit) hover(hit.object.userData.i);
  });
  stage.addEventListener('pointerleave', () => hover(-1));

  /* ---- size + loop ---- */
  function resize() {
    const r = stage.getBoundingClientRect(); const s = Math.max(1, Math.min(r.width, r.height));
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(s, s, false);
    camera.aspect = 1; camera.updateProjectionMatrix();
  }
  resize();
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(stage);

  let raf = 0, running = true, t = 0;
  function loop() {
    if (!running) return;
    raf = requestAnimationFrame(loop);
    t += 0.016; idle += 0.016;
    // idle breathing when the pointer is away
    if (idle > 1.2) { target.y = Math.sin(t * 0.5) * 0.16; target.x = 0.14 + Math.cos(t * 0.4) * 0.06; }
    cur.x += (target.x - cur.x) * 0.06; cur.y += (target.y - cur.y) * 0.06;
    root.rotation.x = cur.x; root.rotation.y = cur.y;
    renderer.render(scene, camera);
  }
  loop();

  // pause when off-screen
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting && !running) { running = true; loop(); }
      else if (!e.isIntersecting) { running = false; cancelAnimationFrame(raf); }
    }), { threshold: 0.05 }).observe(stage);
  }

  function wireLabels2D() { labels.forEach(l => { const i = +l.dataset.i;
    l.addEventListener('pointerenter', () => { setRead(i); labels.forEach((x, k) => x.classList.toggle('on', k === i)); });
    l.addEventListener('pointerleave', () => { setRead(null); labels.forEach(x => x.classList.remove('on')); }); }); }
}

/* ---------- helpers ---------- */
function clamp01(v) { return Math.max(0, Math.min(1, v)); }
function escR(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m])); }

function makeGlow(THREE) {
  const c = document.createElement('canvas'); c.width = c.height = 64;
  const x = c.getContext('2d'); const g = x.createRadialGradient(32, 32, 0, 32, 32, 32);
  g.addColorStop(0, 'rgba(255,255,255,1)'); g.addColorStop(0.25, 'rgba(255,255,255,.7)');
  g.addColorStop(0.6, 'rgba(255,255,255,.15)'); g.addColorStop(1, 'rgba(255,255,255,0)');
  x.fillStyle = g; x.fillRect(0, 0, 64, 64);
  const t = new THREE.CanvasTexture(c); t.needsUpdate = true; return t;
}
function makeDisc(THREE) {
  const c = document.createElement('canvas'); c.width = c.height = 64;
  const x = c.getContext('2d'); x.fillStyle = '#fff'; x.beginPath(); x.arc(32, 32, 22, 0, 7); x.fill();
  const t = new THREE.CanvasTexture(c); t.needsUpdate = true; return t;
}

/* ---------- 2D fallback radar (also fixes the label clip: labels are HTML above) ---------- */
function draw2D(canvas, concerns, N) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2), S = 300;
  canvas.width = S * dpr; canvas.height = S * dpr; canvas.style.width = '100%'; canvas.style.height = '100%';
  const x = canvas.getContext('2d'); x.scale(dpr, dpr);
  const cx = S / 2, cy = S / 2, R = S / 2 - 24;
  const ang = i => (i / N) * Math.PI * 2 - Math.PI / 2;
  x.clearRect(0, 0, S, S);
  x.strokeStyle = 'rgba(255,255,255,.10)'; x.lineWidth = 1;
  for (let g = 1; g <= 4; g++) { x.beginPath(); for (let i = 0; i <= N; i++) { const a = ang(i), r = R * g / 4; const px = cx + Math.cos(a) * r, py = cy + Math.sin(a) * r; i ? x.lineTo(px, py) : x.moveTo(px, py); } x.stroke(); }
  for (let i = 0; i < N; i++) { const a = ang(i); x.strokeStyle = 'rgba(255,255,255,.07)'; x.beginPath(); x.moveTo(cx, cy); x.lineTo(cx + Math.cos(a) * R, cy + Math.sin(a) * R); x.stroke(); }
  x.beginPath(); for (let i = 0; i <= N; i++) { const c = concerns[i % N]; const a = ang(i), r = R * (c.score / 100); const px = cx + Math.cos(a) * r, py = cy + Math.sin(a) * r; i ? x.lineTo(px, py) : x.moveTo(px, py); }
  x.closePath(); x.fillStyle = 'rgba(255,255,255,.12)'; x.fill(); x.strokeStyle = '#fff'; x.lineWidth = 2; x.stroke();
  for (let i = 0; i < N; i++) { const c = concerns[i]; const a = ang(i), r = R * (c.score / 100); x.beginPath(); x.arc(cx + Math.cos(a) * r, cy + Math.sin(a) * r, 3.4, 0, 7); x.fillStyle = GRADE_HEX[c.grade]; x.fill(); }
}


/* ===== ai-providers.js ===== */
/* ============================================================
   ai-providers.js (v2) — vision-AI grading, GROUNDED + 3-tier fallback.
   The prompt now injects the dermatology knowledge base AND the real Siora
   catalog (ingredients, ratings) so grading + recommendations are grounded
   in evidence and the actual products — not a blind guess.
   NOW: mock derives a consistent result from the REAL CV scores + KB.
   LATER: replace call* bodies with fetch('/api/analyze') running
   Groq -> OpenRouter -> Claude server-side. Same return shape.
   ============================================================ */
const PROVIDERS = [
  { id:'groq',       name:'Groq · Llama-4 Scout (vision)' },
  { id:'openrouter', name:'OpenRouter · Llama-4 / Nemotron-VL' },
  { id:'claude',     name:'Anthropic · Claude (vision)' }
];
const wait = ms => new Promise(r=>setTimeout(r,ms));

function createGrader({ knowledge, catalog, config={} }){
  const IDS = Object.keys(knowledge.concerns);

  // LIVE mode: POST to the merchant-configured serverless endpoint (which holds the keys
  // and runs Groq→OpenRouter→Claude server-side). Returns the same shape as the mock.
  async function callLive(payload){
    const r = await fetch(config.aiEndpoint, {
      method:'POST', headers:{'content-type':'application/json'},
      body: JSON.stringify({ faceCropDataURL:payload.faceCropDataURL, cvScores:payload.cvScores, cvMetrics:payload.cvMetrics, profile:payload.profile })
    });
    if(!r.ok) throw new Error('live AI '+r.status);
    const out = await r.json();
    return { ...out, provider: out.provider || 'Live API', providerId:'live' };
  }

  function buildPrompt(cvMetrics, cvScores, profile){
    const science = Object.fromEntries(IDS.map(id=>{
      const c=knowledge.concerns[id]; return [id,{ cause:c.cause, measure:c.measure, actives:c.actives }];
    }));
    const products = catalog.products.map(p=>({ id:p.id, title:p.title, actives:p.actives, rating:p.rating, concerns:p.concerns }));
    return [
      'ROLE: You are a board-certified-dermatologist-informed skin analysis engine.',
      'TASK: Using the face photo + the objective CV measurements + the user profile, grade each',
      'concern A..E (A=excellent, E=priority) with a 0..100 score. Be consistent with CV_SCORES',
      '(they are objective). Then choose primary & secondary concern and a perceived skin age.',
      'Ground every judgement in DERM_SCIENCE and rank actives by INGREDIENT_EFFICACY (0..1 evidence).',
      'Weight advice with REGIONAL_CONTEXT — this user has South-Asian/Pakistani skin (mostly Fitzpatrick',
      'III–V): pigmentation/PIH and UV are the dominant concerns; prefer gentle actives that avoid PIH.',
      "Recommend only from SIORA_PRODUCTS, matching the active to the concern. Return strict JSON:",
      '{concerns:[{id,score,grade}], primary, secondary, perceivedSkinAge, rationale}.',
      'CV_SCORES='+JSON.stringify(cvScores),
      'CV_METRICS='+JSON.stringify(cvMetrics),
      'PROFILE='+JSON.stringify(profile),
      'DERM_SCIENCE='+JSON.stringify(science),
      'INGREDIENT_EFFICACY='+JSON.stringify(knowledge.ingredients),
      'REGIONAL_CONTEXT='+JSON.stringify(knowledge.regionalContext||{}),
      'SIORA_PRODUCTS='+JSON.stringify(products)
    ].join('\n');
  }

  // ---- KB-grounded mock grader ----
  function mockGrade(cvScores, cvMetrics, profile){
    const adj={};
    const age=({'18 to 24':21,'25 to 30':27,'31 to 34':32,'35 to 40':37,'Above 40':44})[profile.age]||27;
    const skin=(profile.skinType||'').toLowerCase();
    IDS.forEach(id=>{
      let s=cvScores[id]??70;
      if(skin.includes('oily')&&['oiliness','pores','acne'].includes(id)) s-=6;
      if(skin.includes('dry')&&['hydration','lines'].includes(id)) s-=8;
      if(profile.sensitive==='Yes'&&id==='redness') s-=8;
      if(age>=35&&['lines','uniformity'].includes(id)) s-=7;
      if(age<=24&&id==='lines') s+=8;
      s+=Math.sin(id.charCodeAt(0)+age)*2;
      adj[id]=Math.max(2,Math.min(100,Math.round(s)));
    });
    const band=s=>s>=85?'A':s>=70?'B':s>=50?'C':s>=30?'D':'E';
    const concerns=IDS.map(id=>({id,score:adj[id],grade:band(adj[id])}));
    const ranked=[...concerns].sort((a,b)=>a.score-b.score);
    // perceived skin age via KB weights
    const w=knowledge.skinAge.weights; let penalty=0,wsum=0;
    for(const id in w){ penalty+=(100-adj[id])*w[id]; wsum+=w[id]; }
    const perceivedSkinAge=Math.max(16,Math.round(age-2+(penalty/Math.max(0.01,wsum))*0.14));
    const overall=Math.round(concerns.reduce((s,c)=>s+c.score,0)/concerns.length);
    return { concerns, primary:ranked[0].id, secondary:ranked[1].id, perceivedSkinAge, overall };
  }

  // provider stubs (swap bodies for real fetches; see README)
  async function callGroq(p){ await wait(420); /* throw new Error('429') to test fallback */ return mockGrade(p.cvScores,p.cvMetrics,p.profile); }
  async function callOpenRouter(p){ await wait(520); return mockGrade(p.cvScores,p.cvMetrics,p.profile); }
  async function callClaude(p){ await wait(620); return mockGrade(p.cvScores,p.cvMetrics,p.profile); }
  const callers={ groq:callGroq, openrouter:callOpenRouter, claude:callClaude };

  async function grade(payload, onProgress){
    let lastErr;
    // try the live merchant endpoint first if configured; fall back to chain on any error
    if(config.aiMode==='live' && config.aiEndpoint){
      try{ onProgress&&onProgress('Live AI'); return await callLive(payload); }
      catch(e){ console.warn('[ai] live endpoint failed → using fallback', e.message); lastErr=e; }
    }
    for(const p of PROVIDERS){
      try{ onProgress&&onProgress(p.name); const out=await callers[p.id](payload); return { ...out, provider:p.name, providerId:p.id }; }
      catch(e){ lastErr=e; console.warn('[ai] '+p.id+' failed → fallback', e.message); }
    }
    throw lastErr||new Error('All AI providers failed');
  }

  return { grade, buildPrompt, PROVIDERS };
}


/* ===== routine-engine.js ===== */
/* ============================================================
   routine-engine.js (v2) — evidence-grounded recommendations.
   Ranks Siora products for each concern by:
     ingredient efficacy (knowledge.json) × evidence weight × review rating.
   Produces AM/PM steps with a scientific "why" (active + mechanism + review),
   and recommends the best-fit Siora Blend (kit) as an upsell.
   ============================================================ */
const EVID = { strong:1.0, good:0.9, moderate:0.78 };

function createRoutineEngine(catalog, knowledge){
  const products = catalog.products, kits = catalog.kits||[];
  const ING = knowledge.ingredients;

  // best active in a product for a concern + its efficacy
  function heroActive(product, concern){
    let best=null, eff=0;
    for(const a of product.actives){
      const ing=ING[a]; if(!ing) continue;
      const e=(ing.treats[concern]||0)*(EVID[ing.evidence]||0.8);
      if(e>eff){ eff=e; best=a; }
    }
    return { active:best, eff };
  }
  // grounded score of a product for a concern
  function scoreProduct(product, concern){
    const { eff } = heroActive(product, concern);
    if(eff<=0) return 0;
    const rating = (product.rating||4.3)/5;          // social proof
    const breadth = product.actives.reduce((s,a)=>s+((ING[a]?.treats[concern]||0)),0)*0.15;
    return eff*0.8 + breadth + rating*0.2;
  }
  function pickFor(concern, step){
    const cands = products.filter(p=>(!step||p.step===step) && p.concerns.includes(concern));
    if(!cands.length) return null;
    return cands.map(p=>({p, s:scoreProduct(p,concern)})).sort((a,b)=>b.s-a.s)[0].p;
  }
  const byId = id => products.find(p=>p.id===id);

  /* ---- combo (kit) scoring, derived from what's ACTUALLY inside each combo ----
     A combo lists its constituent product ids; its treating power for a concern is the
     best efficacy any of its actives provides (ingredient.treats × evidence). We then
     score it against the user's ranked concerns, weighting the worst concerns hardest —
     so the match reflects the real chemistry, not a hand-typed tag. */
  const RANK_W = [1.5, 0.7, 0.42, 0.24, 0.12];      // the WORST concern dominates the match
  const TYPE_W = { serum:1.0, spf:1.0, wash:0.5 };  // rinse-off washes treat far less than leave-on serums
  function comboProducts(kit){ return (kit.products||[]).map(byId).filter(Boolean); }
  // best efficacy the combo delivers for a concern, weighting each product by how much it can
  // actually treat (a serum stays on the skin; a wash is rinsed off in seconds)
  function comboEff(kit, concern){
    let best=0;
    for(const p of comboProducts(kit)){
      const tw=TYPE_W[p.type] ?? 0.8;
      for(const a of (p.actives||[])){ const ing=ING[a]; if(!ing) continue;
        const e=(ing.treats[concern]||0)*(EVID[ing.evidence]||0.8)*tw; if(e>best) best=e; }
    }
    return best;
  }
  function scoreKit(kit, ranked){
    let score=0; const covered=[];
    ranked.forEach((c,i)=>{
      const w=RANK_W[i]||0; if(!w) return;
      const severity=Math.max(0.15,(100-(c.score??70))/100);   // worse concern → higher need
      const eff=comboEff(kit,c.id);
      score += w*severity*eff;
      if(eff>=0.45 && i<3) covered.push(c);                    // concerns it meaningfully treats
    });
    // relevance nudge: reward a combo that was intentionally BUILT for the user's #1 concern
    // (its constituent products lead with that concern), so the pick reads on-target, not just
    // chemically adequate — e.g. a real Pores combo over an acne combo when there is no acne.
    const primary = ranked[0]?.id;
    if(primary) score += comboProducts(kit).filter(p=>(p.concerns||[]).slice(0,2).includes(primary)).length * 0.12;
    score += ((kit.rating||4.5)/5)*0.04;                       // tiny social-proof tie-break
    return { score, covered };
  }

  function whyText(product, concern){
    const { active } = heroActive(product, concern);
    const ing = ING[active];
    const label = (knowledge.concerns[concern]?.scale ? concern : concern);
    return ing ? `${ing.name} ${ing.how.charAt(0).toLowerCase()+ing.how.slice(1)}` : product.subtitle;
  }

  function build(result){
    const primary=result.primaryId, secondary=result.secondaryId;
    const labelFor = id => (result.concerns.find(c=>c.id===id)||{}).label || id;

    const cleanse = pickFor(primary,'cleanse') || pickFor(secondary,'cleanse') || byId('all-in-one-wash');
    const treatA  = pickFor(primary,'treatment') || byId('niacinamide-serum');
    let   treatB  = pickFor(secondary,'treatment');
    if(treatB && treatB.id===treatA.id){
      treatB = products.filter(p=>p.step==='treatment'&&p.id!==treatA.id&&p.concerns.includes(secondary))
                       .sort((a,b)=>scoreProduct(b,secondary)-scoreProduct(a,secondary))[0] || null;
    }
    const hydrate = byId('hyaluronic-serum');
    const spf     = byId('sunblock');

    const mk=(n,label,forText,concernId,product)=>product?{ n,label,forConcern:forText,concernId,product,why:whyText(product,concernId) }:null;

    const am=[ mk(1,'Cleanse',labelFor(primary),primary,cleanse), mk(2,'Treat',labelFor(primary),primary,treatA),
               mk(3,'Hydrate','moisture barrier','hydration',hydrate), mk(4,'Protect','daily defence','pigmentation',spf) ].filter(Boolean);
    let pn=2; const pm=[ mk(1,'Cleanse',labelFor(primary),primary,cleanse), mk(pn++,'Treat',labelFor(primary),primary,treatA),
      treatB?mk(pn++,'Treat',labelFor(secondary),secondary,treatB):null, mk(pn,'Hydrate','overnight repair','hydration',hydrate) ].filter(Boolean);

    // ---- best-fit combo, scored by the real actives inside it vs the user's worst concerns ----
    const ranked = result.concerns;                    // already sorted worst-first
    let kit=null, kbest=-1, matchFor=[], runner=null, rbest=-1;
    for(const k of kits){ const { score, covered } = scoreKit(k, ranked);
      if(score>kbest){ rbest=kbest; runner=kit; kbest=score; kit=k; matchFor=covered; }
      else if(score>rbest){ rbest=score; runner=k; } }
    let recommendedKit=null, altKit=null;
    if(kit){
      const labels=[...new Set(matchFor.map(c=>c.label))];
      const matchReason = labels.length
        ? `Matched to your ${labels.length>1?'top concerns':'top concern'}: ${labels.slice(0,3).join(' + ')}.`
        : 'A strong all-round match for your skin.';
      recommendedKit = { ...kit, matchReason, matchFor:labels };
      // only offer a runner-up if it targets a DIFFERENT concern (a genuine alternative)
      if(runner && runner.id!==kit.id){
        const rcov=scoreKit(runner,ranked).covered.map(c=>c.label).filter(l=>!labels.includes(l));
        if(rcov.length) altKit = { ...runner, matchReason:`Also worth it for: ${rcov.slice(0,2).join(' + ')}.` };
      }
    }

    const all=[...new Map([...am,...pm].map(s=>[s.product.id,s.product])).values()];
    return { am, pm, all, kit: recommendedKit, altKit };
  }
  return { build, scoreProduct };
}


/* ===== integrations.js ===== */
/* ============================================================
   integrations.js — everything that talks to the outside world:
     1. analytics events  (GA4 / GTM dataLayer / gtag / Meta Pixel / custom)
     2. Shopify AJAX cart (real /cart/add.js with variant resolution + drawer refresh)
     3. lead + flywheel persistence (POST to a merchant-configured endpoint)
   All are config-gated and degrade to safe no-ops, so the standalone demo
   never errors and a live Shopify store gets the full behaviour.
   ============================================================ */

/* ---------------- 1. analytics ---------------- */
// Standard-event map so Siora funnel steps light up existing GA4 + Meta Pixel installs.
const FB_STD = { start:'InitiateCheckout', lead:'Lead', add_to_cart:'AddToCart', add_all:'AddToCart', results:'ViewContent' };
function track(event, params){
  params = params || {};
  const debug = (window.SI_CONFIG && window.SI_CONFIG.debug);
  try{
    // Google Tag Manager
    if(Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event:'siora_'+event }, params));
    // GA4 (gtag)
    if(typeof window.gtag === 'function') window.gtag('event', 'siora_'+event, params);
    // Meta Pixel — fire both a custom event and the mapped standard event
    if(typeof window.fbq === 'function'){
      window.fbq('trackCustom', 'Siora'+event.replace(/(^|_)([a-z])/g,(_,__,c)=>c.toUpperCase()), params);
      if(FB_STD[event]) window.fbq('track', FB_STD[event], params);
    }
    // Custom hook a merchant can define
    if(typeof window.SI_TRACK === 'function') window.SI_TRACK(event, params);
  }catch(e){ /* analytics must never break the UX */ }
  if(debug) try{ console.log('[siora:track]', event, params); }catch(e){}
}

/* ---------------- 2. Shopify AJAX cart ---------------- */
const handleOf = url => (String(url||'').match(/\/products\/([^/?#]+)/) || [])[1] || '';
const _variantCache = {};

// Resolve a product handle -> first available variant id via Shopify's public product JSON.
async function resolveVariant(handle){
  if(handle in _variantCache) return _variantCache[handle];
  try{
    const r = await fetch('/products/'+handle+'.js', { headers:{ accept:'application/json' } });
    if(!r.ok) throw new Error('product '+r.status);
    const p = await r.json();
    const v = (p.variants || []).find(v=>v.available) || (p.variants || [])[0];
    return (_variantCache[handle] = v ? v.id : null);
  }catch(e){ return (_variantCache[handle] = null); }
}

// Refresh whatever cart UI the theme uses. Returns true if it drove a visible UI update.
function refreshCartUI(addResponse){
  try{
    const drawer = document.querySelector('cart-drawer');
    if(drawer && typeof drawer.renderContents === 'function'){ drawer.renderContents(addResponse); return true; }
    const notif = document.querySelector('cart-notification');
    if(notif && typeof notif.renderContents === 'function'){ notif.renderContents(addResponse); return true; }
  }catch(e){ /* fall through to bubble */ }
  // Fallback: update the header cart-count bubble from the live cart.
  try{
    fetch('/cart.js', { headers:{ accept:'application/json' } }).then(r=>r.json()).then(c=>{
      document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-count').forEach(el=>{ el.textContent = c.item_count; });
    }).catch(()=>{});
  }catch(e){}
  return false;
}

/* Add one or many items to the live Shopify cart in a single request.
   items: [{ handle, quantity }]. Resolves variants, POSTs /cart/add.js with the
   Dawn section-rendering payload, then refreshes the drawer/notification.
   Returns { ok, count, uiHandled } or throws on hard failure. */
async function shopifyAdd(items){
  const line = [];
  for(const it of (items||[])){
    const id = await resolveVariant(it.handle);
    if(id) line.push({ id, quantity: it.quantity || 1 });
  }
  if(!line.length) throw new Error('no variants resolved');
  const body = { items: line, sections: 'cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button', sections_url: location.pathname };
  const r = await fetch('/cart/add.js', {
    method:'POST',
    headers:{ 'content-type':'application/json', accept:'application/json' },
    body: JSON.stringify(body)
  });
  if(!r.ok){
    let msg = 'cart add '+r.status;
    try{ const e = await r.json(); if(e && e.description) msg = e.description; }catch(_){}
    throw new Error(msg);
  }
  const data = await r.json();
  const uiHandled = refreshCartUI(data);
  return { ok:true, count: line.length, uiHandled };
}

/* ---------------- 3a. native Shopify lead capture ---------------- */
// Uses only Shopify's built-in storefront forms — no app, no external tool, same-origin.
//  (1) form_type=customer  → adds the email to Customers with email-marketing consent (your list)
//  (2) form_type=contact   → (optional) emails full name/phone/skin-summary to your store contact email
function shopifyRoot(){ try{ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }catch(e){ return '/'; } }
function postForm(fields){
  const body = new URLSearchParams(); body.set('utf8','✓');
  for(const k in fields){ if(fields[k]!=null && fields[k]!=='') body.set(k, fields[k]); }
  return fetch(shopifyRoot()+'contact', {
    method:'POST', headers:{ 'content-type':'application/x-www-form-urlencoded' },
    body: body.toString(), keepalive:true
  }).then(r=>({ ok: r.ok || r.status===302 || r.status===200, status:r.status }))
    .catch(e=>({ ok:false, error:e.message }));
}
async function shopifyLead(profile, opts){
  opts = opts || {};
  const out = {};
  // 1) always: subscribe the email (builds the marketing list, tagged so you can segment)
  out.subscribe = await postForm({ form_type:'customer', 'contact[email]': profile.email, 'contact[tags]': opts.tags || 'skin-insights,newsletter' });
  // 2) optional: send the full lead detail (name/phone/summary) to your store contact email
  if(opts.emailDetails){
    out.contact = await postForm({ form_type:'contact',
      'contact[name]': profile.name || '', 'contact[email]': profile.email, 'contact[phone]': profile.phone || '',
      'contact[body]': `New SkinInsights lead.\nName: ${profile.name||'—'}\nPhone: ${profile.phone||'—'}\n`+
        `Skin type: ${profile.skinType||'—'} · Age: ${profile.age||'—'} · Sensitive: ${profile.sensitive||'—'}\n`+
        (opts.summary ? `Result: ${opts.summary}\n` : '')+`Marketing opt-in: ${profile.optin?'yes':'no'}` });
  }
  return out;
}

/* ---------------- 3b. lead + flywheel persistence (custom endpoint) ---------------- */
// Fire-and-forget POST that never rejects — the funnel must not stall on a network hiccup.
async function postJSON(endpoint, payload){
  if(!endpoint) return { ok:false, skipped:true };
  try{
    const r = await fetch(endpoint, {
      method:'POST',
      headers:{ 'content-type':'application/json' },
      body: JSON.stringify(payload),
      keepalive: true                 // survives a page unload right after submit
    });
    // Read the body when there is one — the scan call returns the row id, and the
    // report call returns a download link. Never let a parse failure reject.
    let data = null;
    try{ data = await r.clone().json(); }catch(_){}
    return { ok: r.ok, status: r.status, data };
  }catch(e){ return { ok:false, error: e.message }; }
}


/* ===== ui.js ===== */
/* ============================================================
   ui.js (v2) — questionnaire + science-rich results + grounded routine.
   ============================================================ */
const GRADE_COLOR = { A:'#1f9d61', B:'#5bbf6a', C:'#d6a31e', D:'#d68a1e', E:'#c0392b' };
const money = (sym,n)=> sym + Number(n).toLocaleString('en-PK');
const esc = s => String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

let toastT;
function toast(msg){
  const el=document.getElementById('siToast'); el.textContent=msg; el.hidden=false;
  requestAnimationFrame(()=>el.classList.add('show'));
  clearTimeout(toastT); toastT=setTimeout(()=>{ el.classList.remove('show'); setTimeout(()=>el.hidden=true,300); },2000);
}
function stars(rating){
  const full=Math.floor(rating), half=rating-full>=0.4;
  let s=''; for(let i=0;i<5;i++) s+= i<full?'★': (i===full&&half?'⯪':'☆'); return s;
}

/* ---------------- Questionnaire ---------------- */
const QUESTIONS=[
  { key:'name',type:'text',q:"Hi there — what's your name?",placeholder:'Your first name'},
  { key:'age',type:'choice',q:'Which age group do you belong to?',opts:['18 to 24','25 to 30','31 to 34','35 to 40','Above 40']},
  { key:'gender',type:'choice',q:'What is your gender?',opts:[['Female','♀'],['Male','♂'],['Prefer not to say','•']]},
  { key:'skinType',type:'choice',q:'How would you describe your skin?',opts:[['Oily / Combination','🛢'],['Dry','🏜'],['Normal','🌿']]},
  { key:'sensitive',type:'choice',q:'Is your skin sensitive?',opts:['Yes','Sometimes','No']}
];
function createQuestionnaire(el,onComplete,onBack){
  let i=0; const profile={};
  function render(){
    const Q=QUESTIONS[i];
    const dots=QUESTIONS.map((_,k)=>`<i class="${k<i?'done':k===i?'now':''}"></i>`).join('');
    const body = Q.type==='text'
      ? `<input class="si-qtext" id="siQText" type="text" placeholder="${Q.placeholder}" value="${esc(profile[Q.key]||'')}" autocomplete="given-name" enterkeyhint="next" autofocus>
         <p class="si-qhint">Press <b>Enter ↵</b> to continue</p>`
      : `<div class="si-q-opts">`+Q.opts.map(o=>{ const [l,ic]=Array.isArray(o)?o:[o,null]; const sel=profile[Q.key]===l?'sel':'';
          return `<button class="si-q-opt ${sel}" data-v="${esc(l)}"><span class="si-q-optlabel">${ic?`<span class="si-q-ic">${ic}</span>`:''}${esc(l)}</span><span class="si-rad"></span></button>`; }).join('')+`</div>`;
    /* No Next button: choices auto-advance on tap, the name field auto-advances on Enter.
       The visitor never has to hunt for a button. */
    el.innerHTML=`<div class="si-dots">${dots}</div>
      <h2 class="si-h2" style="text-align:center;max-width:18ch;margin:0 auto 22px">${esc(Q.q)}</h2>${body}`;
    if(Q.type==='choice'){
      el.querySelectorAll('.si-q-opt').forEach(b=>b.addEventListener('click',()=>{ profile[Q.key]=b.dataset.v; el.querySelectorAll('.si-q-opt').forEach(x=>x.classList.remove('sel')); b.classList.add('sel'); setTimeout(next,220); }));
    } else {
      const inp=el.querySelector('#siQText');
      requestAnimationFrame(()=>inp.focus());
      const submit=()=>{ profile.name=(inp.value||'').trim(); if(!profile.name){ inp.classList.add('shake'); setTimeout(()=>inp.classList.remove('shake'),400); inp.focus(); return; } next(); };
      inp.addEventListener('keydown',e=>{ if(e.key==='Enter'){ e.preventDefault(); submit(); } });
    }
  }
  function next(){ i<QUESTIONS.length-1 ? (i++,render()) : onComplete({...profile}); }
  function back(){ i>0 ? (i--,render()) : onBack&&onBack(); }
  render(); return { back };
}
const s=document.createElement('style');
s.textContent=`.si-qtext{width:100%;border:0;border-bottom:2px solid var(--ink);font-family:var(--head);font-size:22.4px;padding:10px 2px;text-align:center;outline:none}`;
document.head.appendChild(s);


/* ---------------- Results ---------------- */
function renderResults(el, r, sym, config, onSeeRoutine, onSaveReport){
  config = config||{};
  const show = k => config[k]!==false;   // toggles default ON
  const conf=Math.round(r.confidence*100);
  const overall=r.overall;
  const oCol = overall>=80?(config.accent||'#1f9d61'):overall>=60?'#d6a31e':'#c0392b';
  // fixed concern order for the radar (stable shape)
  const order=['acne','oiliness','pores','pigmentation','skinTone','uniformity','redness','hydration','lines','darkCircles'];
  const radarConcerns = order.map(id=>r.concerns.find(c=>c.id===id)).filter(Boolean);
  const cards=r.concerns.map(c=>{ const col=GRADE_COLOR[c.grade];
    return `<button class="si-grade" data-id="${c.id}"><div class="si-grade__ring" style="--g:${col};--p:${c.score}"><span class="si-grade__g" style="color:${col}">${c.grade}</span></div><div class="si-grade__l">${esc(c.label)}</div></button>`; }).join('');

  el.innerHTML=`
    <div class="si-res-head">
      <p class="si-eyebrow">Your SkinInsights report</p>
      <div class="si-res-photo"><img src="${r.dataURL}" alt="Your scan"></div>
      <h2 class="si-h2">Here's what we found${r.profile.name?`, ${esc(r.profile.name)}`:''}.</h2>
    </div>

    <div class="si-scorebar">
      <div class="si-bigring" style="--g:${oCol};--p:${overall}"><div><b style="color:${oCol}">${overall}</b><span>Skin Health</span></div></div>
      <div class="si-summary2">
        <div class="si-sum"><h4>Primary concern</h4><b>${esc(r.primaryConcern)}</b></div>
        <div class="si-sum"><h4>Secondary concern</h4><b>${esc(r.secondaryConcern)}</b></div>
        ${show('showAge')?`<div class="si-sum si-sum--ink"><div><h4>Perceived skin age</h4>${r.ageDelta>0?`<span class="si-agedelta">${r.ageDelta} yr${r.ageDelta>1?'s':''} younger ✦</span>`:r.ageDelta<0?`<span class="si-agedelta warn">${-r.ageDelta} yr${r.ageDelta<-1?'s':''} older</span>`:''}</div><b class="si-age">${r.perceivedSkinAge}</b></div>`:''}
      </div>
    </div>

    ${r.retake?`<div class="si-retake">📷 Lighting/clarity was off — your result is approximate. <b>Retake</b> in even light for a sharper analysis.</div>`:''}

    ${(show('showArchetype') && r.archetype)?`<div class="si-arche">
      <div class="si-arche__top"><span class="si-tone-sw" style="background:${r.skinTone?.hex||'#caa'}"></span>
        <div><span class="si-arche__k">Your skin archetype</span><b>${esc(r.archetype.name)}</b></div></div>
      <p>${esc(r.archetype.blurb)}</p>
      ${r.skinTone?`<div class="si-tonechips"><span>Tone · Monk ${r.skinTone.monk} (${esc(r.skinTone.monkLabel)})</span><span>Fitzpatrick ${r.skinTone.fitzpatrick}</span></div>`:''}
    </div>`:''}

    ${show('showRadar')?`<div class="si-section-title">Your skin map</div>
    <div class="si-radar" id="siRadar"></div>`:''}

    <div class="si-section-title">Graded concerns</div>
    <p class="si-sub" style="margin-top:2px">Tap any concern for the science + what helps.</p>
    <div class="si-grade-grid">${cards}</div>
    <div class="si-detail" id="siDetail"></div>

    ${(show('showSafety') && r.safetyVerdict)?`<div class="si-safetycard ${r.safetyVerdict.flag?'flag':'clear'}">
      <div class="si-safetycard__h">${r.safetyVerdict.flag?'⚠ Worth a professional check':'✓ Skin-health check'}</div>
      <p>${esc(r.safetyVerdict.message)}</p>
      ${r.safetyVerdict.flag?`<p class="si-abcde"><b>ABCDE rule:</b> ${esc(r.safetyVerdict.abcde)}</p>`:''}
    </div>`:''}

    <button class="si-btn si-btn--primary" id="siToRoutine" style="margin-top:26px">Build my Siora routine →</button>
    <div class="si-res-actions">${config.leadEndpoint?`<button class="si-btn si-btn--ghost" id="siSaveReport">⬇ Download PDF report</button>`:''}<button class="si-btn si-btn--ghost" id="siShare">📸 Share card</button></div>
    <p class="si-disclaimer">Indicative, dermatologist-informed guidance — not a medical diagnosis.</p>`;

  const rcv=el.querySelector('#siRadar'); if(rcv) createSkinRadar(rcv, radarConcerns);

  const detail=el.querySelector('#siDetail');
  el.querySelectorAll('.si-grade').forEach(b=>b.addEventListener('click',()=>{
    el.querySelectorAll('.si-grade').forEach(x=>x.classList.remove('sel')); b.classList.add('sel');
    const c=r.concerns.find(x=>x.id===b.dataset.id), sc=c.science;
    detail.innerHTML=`
      <h5>${esc(c.label)} — Grade ${c.grade} <span style="color:${GRADE_COLOR[c.grade]}">(${esc(c.bandLabel)})</span></h5>
      ${c.clinical?`<div class="si-clinical">≈ <b>${esc(c.clinical.label)}</b> · ${esc(c.clinical.ref)}</div>`:''}
      <div class="si-detail__grid">
        <div><span class="si-detail__k">Why it happens</span><p>${esc(sc.cause)}</p></div>
        <div><span class="si-detail__k">What we measured</span><p>${esc(c.saw)}</p></div>
      </div>
      ${sc.actives.length?`<div class="si-detail__act"><span class="si-detail__k">Proven actives</span><div class="si-chips">${sc.actives.map(a=>`<span class="si-chip">${esc(a.name)}</span>`).join('')}</div></div>`:''}
      <div class="si-detail__tip">💡 ${esc(sc.tip)}</div>`;
    detail.classList.add('show'); detail.scrollIntoView({block:'nearest',behavior:'smooth'});
  }));
  el.querySelector('#siToRoutine').addEventListener('click',onSeeRoutine);
  const sv=el.querySelector('#siSaveReport'); if(sv) sv.addEventListener('click',onSaveReport);
  el.querySelector('#siShare').addEventListener('click',()=>shareCard(r));
}

/* downloadable / shareable result card (PNG) */
function shareCard(r){
  const W=800,H=1000,c=document.createElement('canvas'); c.width=W;c.height=H; const x=c.getContext('2d');
  x.fillStyle='#fff'; x.fillRect(0,0,W,H);
  x.fillStyle='#121212'; x.font='800 30px Assistant, sans-serif'; x.fillText('SIORA · SKININSIGHTS', 48, 70);
  x.strokeStyle='#eee'; x.beginPath(); x.moveTo(48,92); x.lineTo(W-48,92); x.stroke();
  // overall ring
  const cx=160,cy=230,R=92;
  x.lineWidth=18; x.strokeStyle='#eee'; x.beginPath(); x.arc(cx,cy,R,0,7); x.stroke();
  const col=r.overall>=80?'#1f9d61':r.overall>=60?'#d6a31e':'#c0392b';
  x.strokeStyle=col; x.beginPath(); x.arc(cx,cy,R,-Math.PI/2,-Math.PI/2+Math.PI*2*(r.overall/100)); x.stroke();
  x.fillStyle=col; x.font='800 56px Assistant'; x.textAlign='center'; x.fillText(r.overall,cx,cy+8);
  x.fillStyle='#888'; x.font='600 15px Poppins'; x.fillText('SKIN HEALTH',cx,cy+38);
  x.textAlign='left';
  // info
  x.fillStyle='#121212'; x.font='700 26px Assistant'; x.fillText((r.profile.name||'Your')+"'s skin report", 290, 180);
  x.font='400 18px Poppins'; x.fillStyle='#555';
  x.fillText('Primary: '+r.primaryConcern, 290, 220);
  x.fillText('Secondary: '+r.secondaryConcern, 290, 250);
  x.fillText('Perceived skin age: '+r.perceivedSkinAge, 290, 280);
  if(r.archetype){ x.fillStyle='#121212'; x.font='700 18px Poppins'; x.fillText(r.archetype.name, 290, 315); }
  // grade bars
  let gy=400; x.font='600 16px Poppins';
  r.concerns.forEach(co=>{ const gc=GRADE_COLOR[co.grade];
    x.fillStyle='#121212'; x.fillText(co.label,48,gy+4);
    x.fillStyle='#eee'; x.fillRect(300,gy-12,420,16);
    x.fillStyle=gc; x.fillRect(300,gy-12,420*(co.score/100),16);
    x.fillStyle=gc; x.font='700 15px Assistant'; x.fillText(co.grade,732,gy+4); x.font='600 16px Poppins';
    gy+=46; });
  x.fillStyle='#999'; x.font='400 14px Poppins'; x.textAlign='center';
  x.fillText('Get your free AI skin analysis at siora.pk', W/2, H-50);
  x.fillText('Indicative guidance — not a medical diagnosis', W/2, H-26);
  const a=document.createElement('a'); a.download='siora-skin-report.png'; a.href=c.toDataURL('image/png'); a.click();
  track('share_card', { overall:r.overall });
  toast('Result card downloaded');
}

/* ---------------- Routine ---------------- */
function renderRoutine(el, routine, sym, knowledge, result, onAdd, onAddAll, onViewCart){
  let mode='am';
  const ING=knowledge.ingredients, TL=knowledge.timelines||{}, CONF=knowledge.conflicts||[];
  const chips = p => (p.actives||[]).slice(0,3).map(a=>`<span class="si-ichip">${esc(ING[a]?.name||a)}</span>`).join('');
  const timeline = p => { const t=TL[(p.actives||[])[0]]; return t?`<p class="si-timeline">⏱ Visible results in <b>${esc(t)}</b></p>`:''; };
  function stepHTML(s){ const p=s.product;
    return `<div class="si-rstep">
      <div class="si-rstep__top"><span class="si-rstep__n">Step ${s.n}</span> ${s.label}<span class="si-rstep__for">for ${esc(s.forConcern)}</span></div>
      <div class="si-rcard">
        <a class="si-rcard__img" href="${p.url}" target="_blank" rel="noopener"><img src="${p.image}" alt="${esc(p.title)}" loading="lazy" onerror="this.style.opacity=.18"></a>
        <div class="si-rcard__b">
          <h4>${esc(p.title)}</h4>
          <div class="si-rstars">${stars(p.rating||4.4)} <span>${(p.rating||4.4).toFixed(1)} · ${p.reviews||0} reviews</span></div>
          <div class="si-ichips">${chips(p)}</div>
          <p class="si-rcard__why"><b>Why for you:</b> ${esc(s.why)}</p>
          ${timeline(p)}
          ${p.reviewSnippet?`<p class="si-rev">“${esc(p.reviewSnippet)}”</p>`:''}
          <div class="si-rcard__row">
            <span class="si-price">${p.compareAt?`<s>${money(sym,p.compareAt)}</s>`:''}${money(sym,p.price)}</span>
            <button class="si-add" data-id="${p.id}">Add to cart</button>
          </div>
        </div></div></div>`;
  }
  // 8-week projection for the primary concern
  function projectionHTML(){
    if(!result) return '';
    const c=result.concerns.find(x=>x.id===result.primaryId); if(!c) return '';
    const proj=Math.min(96, c.score + Math.round((100-c.score)*0.45)); // evidence-based uplift
    return `<div class="si-proj">
      <div class="si-proj__h">Projected in 8 weeks · ${esc(c.label)}</div>
      <div class="si-proj__bar"><span class="now" style="width:${c.score}%"></span><span class="goal" style="width:${proj}%"></span></div>
      <div class="si-proj__lbl"><span>Now ${c.score}</span><span>Goal ${proj} ✦</span></div>
      <p class="si-proj__note">With consistent use of this routine, most people see meaningful improvement in their primary concern within 8 weeks.</p>
    </div>`;
  }
  // ingredient-conflict safety note across the routine
  function conflictHTML(){
    const actives=new Set(routine.all.flatMap(p=>p.actives||[]));
    for(const [a,b,msg] of CONF){ if(actives.has(a)&&actives.has(b)) return `<div class="si-safety">⚠ <b>${esc(ING[a]?.name||a)} + ${esc(ING[b]?.name||b)}:</b> ${esc(msg)}</div>`; }
    return '';
  }
  function kitHTML(k){ if(!k) return '';
    return `<div class="si-kit">
      <div class="si-kit__tag">✦ Your best-match combo</div>
      <div class="si-kit__row">
        <div class="si-kit__img"><img src="${k.image}" alt="${esc(k.title)}" onerror="this.style.opacity=.18"></div>
        <div class="si-kit__b"><h4>${esc(k.title)}</h4>
          ${k.matchReason?`<p class="si-kit__match">${esc(k.matchReason)}</p>`:''}
          <div class="si-rstars">${stars(k.rating||4.7)} <span>${(k.rating||4.7).toFixed(1)} · ${k.reviews||0}</span></div>
          <p class="si-rcard__why">${esc(k.blurb||k.subtitle)}</p>
          <div class="si-rcard__row"><span class="si-price">${k.compareAt?`<s>${money(sym,k.compareAt)}</s>`:''}${money(sym,k.price)}</span>
            <button class="si-add si-add--dark" data-kit="${k.id}">Add combo</button></div>
        </div></div></div>`;
  }
  function altHTML(k){ if(!k) return '';
    return `<a class="si-kit__alt" href="${esc(k.url||'#')}" target="_blank" rel="noopener">
      <span class="si-kit__alt-t">Prefer to focus elsewhere? <b>${esc(k.title)}</b></span>
      <span class="si-kit__alt-w">${esc(k.matchReason||'')}</span></a>`;
  }
  function paint(){
    el.querySelector('#siSteps').innerHTML=(mode==='am'?routine.am:routine.pm).map(stepHTML).join('');
    el.querySelector('[data-m="am"]').classList.toggle('sel',mode==='am');
    el.querySelector('[data-m="pm"]').classList.toggle('sel',mode==='pm');
    el.querySelectorAll('.si-add').forEach(b=>b.addEventListener('click',()=>{ onAdd(b.dataset.id||b.dataset.kit); b.classList.add('added'); b.textContent='Added ✓'; }));
  }
  const total=routine.all.reduce((s,p)=>s+p.price,0);
  el.innerHTML=`
    <p class="si-eyebrow" style="text-align:center">Your personalised routine</p>
    <h2 class="si-h2" style="text-align:center;max-width:20ch;margin:0 auto 6px">Built for your skin, by Siora.</h2>
    <p class="si-sub" style="text-align:center">${routine.all.length} products · cleanse → treat → hydrate → protect.</p>
    ${projectionHTML()}
    ${kitHTML(routine.kit)}
    ${altHTML(routine.altKit)}
    <div class="si-amp"><button data-m="am">☀ Morning</button><button data-m="pm">☾ Night</button></div>
    <div id="siSteps"></div>
    ${conflictHTML()}
    <div class="si-routine-cta">
      <button class="si-btn si-btn--ghost" id="siViewCart">View cart</button>
      <button class="si-btn si-btn--primary" id="siAddAll">Add all · ${money(sym,total)}</button>
    </div>
    <p class="si-disclaimer">Routine generated from your scan + Siora's evidence-based formulas. Patch-test new actives.</p>`;
  el.querySelector('[data-m="am"]').addEventListener('click',()=>{mode='am';paint();});
  el.querySelector('[data-m="pm"]').addEventListener('click',()=>{mode='pm';paint();});
  el.querySelector('#siAddAll').addEventListener('click',()=>onAddAll(routine.all));
  el.querySelector('#siViewCart').addEventListener('click',()=> onViewCart ? onViewCart() : toast('Cart preview — wired to Shopify AJAX cart on launch.'));
  paint();
}


/* ===== camera.js ===== */
/* ============================================================
   camera.js — getUserMedia + MediaPipe FaceLandmarker live guidance
   + best-of-N auto capture. Everything stays in the browser.
   Falls back to a brightness/centre heuristic if MediaPipe can't load.
   ============================================================ */

let faceLandmarker = null;
let mpReady = false;

async function loadMediaPipe(){
  if (mpReady) return true;
  try{
    const vision = await import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/vision_bundle.mjs');
    const fileset = await vision.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm');
    faceLandmarker = await vision.FaceLandmarker.createFromOptions(fileset, {
      baseOptions:{ modelAssetPath:'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task' },
      runningMode:'VIDEO', numFaces:1, outputFaceBlendshapes:false
    });
    mpReady = true;
    return true;
  }catch(e){
    console.warn('[camera] MediaPipe unavailable, using fallback guidance.', e);
    return false;
  }
}

// IMAGE-mode landmarker for the photo-upload path (separate from the live VIDEO one)
let imageLandmarker = null, imgReady = false;
async function loadImageLandmarker(){
  if (imgReady) return true;
  try{
    const vision = await import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/vision_bundle.mjs');
    const fileset = await vision.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm');
    imageLandmarker = await vision.FaceLandmarker.createFromOptions(fileset, {
      baseOptions:{ modelAssetPath:'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task' },
      runningMode:'IMAGE', numFaces:1, outputFaceBlendshapes:false
    });
    imgReady = true;
    return true;
  }catch(e){
    console.warn('[upload] image landmarker unavailable → fraction-box CV.', e);
    return false;
  }
}

// average brightness of the current frame (downscaled)
function frameBrightness(video){
  const c=document.createElement('canvas'); c.width=48; c.height=64;
  const x=c.getContext('2d'); x.drawImage(video,0,0,48,64);
  const d=x.getImageData(0,0,48,64).data; let s=0;
  for(let i=0;i<d.length;i+=4) s+=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2];
  return s/(d.length/4); // 0..255
}

function createCapture(dom, onCaptured){
  const { video, overlay, ring, hint, checks, count, shutter, retake, auto } = dom;
  let stream=null, raf=null, lastBox=null, alignedFor=0, lastT=0, capturing=false, captured=false;
  const ctx = overlay.getContext('2d');
  const chk = k => checks.querySelector(`[data-k="${k}"]`);
  const setChk=(k,ok)=>chk(k)&&chk(k).classList.toggle('ok',ok);

  async function start(){
    captured=false; capturing=false; alignedFor=0;
    shutter.disabled=true; retake.hidden=true; auto.hidden=false; count.hidden=true;
    hint.textContent='Loading camera…';
    try{
      stream = await navigator.mediaDevices.getUserMedia({ video:{ facingMode:'user', width:{ideal:1280}, height:{ideal:1280} }, audio:false });
      video.srcObject = stream;
      await video.play();
    }catch(e){
      hint.textContent='⚠ Camera blocked. Allow camera access and reload.';
      return;
    }
    loadMediaPipe().then(()=>{ hint.textContent = mpReady ? 'Position your face in the circle' : 'Center your face in the circle'; });
    sizeOverlay();
    loop();
  }

  function sizeOverlay(){
    overlay.width = video.videoWidth || 720;
    overlay.height = video.videoHeight || 960;
  }

  function loop(t){
    raf = requestAnimationFrame(loop);
    if(video.readyState < 2 || captured) return;
    if(overlay.width !== video.videoWidth) sizeOverlay();

    let box=null;
    if(mpReady && faceLandmarker){
      let res; try{ res = faceLandmarker.detectForVideo(video, performance.now()); }catch(e){ res=null; }
      if(res && res.faceLandmarks && res.faceLandmarks.length){
        const lm = res.faceLandmarks[0];
        let minx=1,miny=1,maxx=0,maxy=0;
        for(const p of lm){ minx=Math.min(minx,p.x); miny=Math.min(miny,p.y); maxx=Math.max(maxx,p.x); maxy=Math.max(maxy,p.y); }
        box={x:minx,y:miny,w:maxx-minx,h:maxy-miny,landmarks:lm};
      }
    }
    evaluate(box);
  }

  function evaluate(box){
    ctx.clearRect(0,0,overlay.width,overlay.height);
    const bright = frameBrightness(video);
    const lightOK = bright>70 && bright<210;
    setChk('light', lightOK);

    let centerOK=false, sizeOK=false, steadyOK=false, faceOK=false;
    if(box){
      faceOK=true;
      const cx=box.x+box.w/2, cy=box.y+box.h/2;
      centerOK = Math.abs(cx-0.5)<0.13 && Math.abs(cy-0.46)<0.15;
      sizeOK   = box.w>0.34 && box.w<0.8;
      if(lastBox){ const mv=Math.abs(cx-(lastBox.x+lastBox.w/2))+Math.abs(cy-(lastBox.y+lastBox.h/2)); steadyOK = mv<0.012; }
      lastBox=box;
      // draw mesh dots (subtle)
      if(box.landmarks){
        ctx.fillStyle='rgba(70,224,138,.55)';
        for(let i=0;i<box.landmarks.length;i+=6){ const p=box.landmarks[i]; ctx.fillRect(p.x*overlay.width-1,p.y*overlay.height-1,2,2); }
      }
    } else if(!mpReady){
      // fallback: rely on brightness + assume framing; let user shoot manually
      faceOK=true; centerOK=true; sizeOK=true; steadyOK=true;
    }
    setChk('center',centerOK); setChk('size',sizeOK); setChk('steady',steadyOK);

    const allGood = lightOK && centerOK && sizeOK && steadyOK && faceOK;
    ring.classList.toggle('ok',allGood);
    shutter.disabled = !faceOK;

    if(!faceOK) hint.textContent='Bring your face into the circle';
    else if(!lightOK) hint.textContent = bright<=70 ? 'A little more light, please' : 'Too bright — soften the light';
    else if(!sizeOK) hint.textContent = (box && box.w<0.34) ? 'Come a little closer' : 'Move back slightly';
    else if(!centerOK) hint.textContent='Center your face';
    else if(!steadyOK) hint.textContent='Hold steady…';
    else hint.textContent='Perfect — hold still';

    // auto-capture when aligned for ~0.9s
    const now=performance.now();
    if(allGood){ alignedFor += lastT? now-lastT : 0; } else { alignedFor=0; }
    lastT=now;
    if(mpReady && allGood && alignedFor>900 && !capturing){ doCountdownCapture(box); }
  }

  function doCountdownCapture(box){
    capturing=true; auto.hidden=true; count.hidden=false;
    let n=3; count.textContent=n;
    const iv=setInterval(()=>{
      n--; if(n<=0){ clearInterval(iv); count.hidden=true; capture(box); }
      else count.textContent=n;
    },650);
  }

  // shared: crop a full-res canvas to the padded face box (or centre 3:4), emit result — no stretching
  function emitFromCanvas(full, W, H, box){
    let cx0,cy0,cw,ch;
    if(box){ const pad=0.45;
      cx0=Math.max(0,(box.x-box.w*pad))*W; cy0=Math.max(0,(box.y-box.h*pad))*H;
      const cx1=Math.min(1,(box.x+box.w*(1+pad)))*W, cy1=Math.min(1,(box.y+box.h*(1+pad)))*H;
      cw=cx1-cx0; ch=cy1-cy0;
    } else { cw=Math.min(W,H*0.75); ch=cw*4/3; cx0=(W-cw)/2; cy0=(H-ch)/2; }
    const cropAR=cw/ch, dW=380, dH=Math.round(dW/cropAR);
    const crop=document.createElement('canvas'); crop.width=dW; crop.height=dH;
    const cctx=crop.getContext('2d'); cctx.drawImage(full, cx0,cy0,cw,ch, 0,0,dW,dH);
    const imageData=cctx.getImageData(0,0,dW,dH);
    const dataURL=crop.toDataURL('image/jpeg',0.92);
    let landmarks=null;
    if(box && box.landmarks){ landmarks=box.landmarks.map(p=>({ x:(p.x*W-cx0)/cw, y:(p.y*H-cy0)/ch })); }
    onCaptured({ dataURL, imageData, landmarks, faceBox:box });
  }

  function capture(box){
    captured=true;
    const W=video.videoWidth, H=video.videoHeight;
    const full=document.createElement('canvas'); full.width=W; full.height=H;
    full.getContext('2d').drawImage(video,0,0,W,H);
    stop(); retake.hidden=false;
    emitFromCanvas(full, W, H, box);
  }

  // ---- photo-upload fallback (no camera / desktop / permission denied) ----
  async function fromFile(file){
    if(!file || !/^image\//.test(file.type||'')){ hint.textContent='Please choose an image file (JPG or PNG).'; return; }
    stop(); captured=true; capturing=true;
    hint.textContent='Reading your photo…';
    const url=URL.createObjectURL(file), img=new Image();
    img.onload=async ()=>{
      URL.revokeObjectURL(url);
      const maxW=900, sc=Math.min(1, maxW/(img.naturalWidth||maxW));
      const W=Math.max(1,Math.round((img.naturalWidth||maxW)*sc)), H=Math.max(1,Math.round((img.naturalHeight||maxW)*sc));
      const full=document.createElement('canvas'); full.width=W; full.height=H;
      full.getContext('2d').drawImage(img,0,0,W,H);
      let box=null;
      if(await loadImageLandmarker()){
        try{ const res=imageLandmarker.detect(full);
          if(res && res.faceLandmarks && res.faceLandmarks.length){ const lm=res.faceLandmarks[0];
            let mnx=1,mny=1,mxx=0,mxy=0; for(const p of lm){ mnx=Math.min(mnx,p.x); mny=Math.min(mny,p.y); mxx=Math.max(mxx,p.x); mxy=Math.max(mxy,p.y); }
            box={ x:mnx, y:mny, w:mxx-mnx, h:mxy-mny, landmarks:lm };
          }
        }catch(e){ console.warn('[upload] detect failed → fraction CV', e); }
      }
      retake.hidden=false;
      emitFromCanvas(full, W, H, box);
    };
    img.onerror=()=>{ hint.textContent="Couldn't read that image — please try another."; captured=false; capturing=false; };
    img.src=url;
  }

  function stop(){ if(raf) cancelAnimationFrame(raf); if(stream){ stream.getTracks().forEach(t=>t.stop()); stream=null; } }

  shutter.addEventListener('click',()=>{ if(!shutter.disabled && !captured) capture(lastBox); });
  retake.addEventListener('click',()=>{ start(); });

  return { start, stop, fromFile };
}


/* ===== analysis-engine.js ===== */
/* ============================================================
   analysis-engine.js (v2) — orchestrates CV + grounded AI into one result,
   enriched with dermatology science + measured values + a Skin Health Score.
   ============================================================ */

function createAnalysisEngine(concernsData, knowledge, catalog, config={}){
  const grader = createGrader({ knowledge, catalog, config });
  const byId = Object.fromEntries(concernsData.concerns.map(c=>[c.id,c]));
  const bandLabel = g => (concernsData.gradeBands.find(b=>b.grade===g)||{}).label || '';
  const ING = knowledge.ingredients;

  function scienceFor(id){
    const k = knowledge.concerns[id] || {};
    const actives = (k.actives||[]).slice(0,3).map(a=>({ name:ING[a]?.name||a, how:ING[a]?.how||'' }));
    return { cause:k.cause||'', measure:k.measure||'', tip:k.tip||'', actives };
  }

  async function analyze({ imageData, dataURL, landmarks, profile }, onProgress){
    onProgress&&onProgress('detect'); await sleep(320);

    onProgress&&onProgress('measure');
    const cv = analyzeImageData(imageData, landmarks);
    const { metrics:cvMetrics, scores:cvScores, confidence:cvConf, skinTone, quality, retake, safety } = cv;
    await sleep(380);
    const clinicalBand = (id,score)=>{ const cs=knowledge.clinicalScales?.[id]; if(!cs) return null;
      for(const [min,label] of cs.bands){ if(score>=min) return { label, ref:cs.ref }; } return null; };

    onProgress&&onProgress('grade');
    const ai = await grader.grade({ faceCropDataURL:dataURL, cvScores, cvMetrics, profile }, ()=>{});

    const concerns = ai.concerns.map(c=>{
      const meta = byId[c.id]||{};
      return { id:c.id, label:meta.label||c.id, grade:c.grade, score:c.score, bandLabel:bandLabel(c.grade),
               saw:meta.saw||'', helps:meta.helps||'', science:scienceFor(c.id), clinical:clinicalBand(c.id,c.score) };
    }).sort((a,b)=>a.score-b.score);

    const safetyVerdict = {
      flag: !!(safety && safety.flag),
      message: (safety && safety.flag) ? knowledge.safety.flagMessage : knowledge.safety.clearMessage,
      abcde: knowledge.safety.abcde
    };

    onProgress&&onProgress('routine'); await sleep(260);

    const archetype = buildArchetype(ai.concerns, profile, skinTone);
    const sc = id => (ai.concerns.find(c=>c.id===id)||{}).score ?? 70;

    return {
      dataURL, cvMetrics, concerns, skinTone, quality, retake, archetype, safety, safetyVerdict,
      primaryConcern: byId[ai.primary]?.label||ai.primary,
      secondaryConcern: byId[ai.secondary]?.label||ai.secondary,
      primaryId: ai.primary, secondaryId: ai.secondary,
      perceivedSkinAge: ai.perceivedSkinAge,
      ageDelta: (({'18 to 24':21,'25 to 30':27,'31 to 34':32,'35 to 40':37,'Above 40':44})[profile.age]||27) - ai.perceivedSkinAge,
      overall: ai.overall,
      confidence: Math.min(0.97, cvConf*0.6 + 0.38),
      provider: ai.provider, profile
    };

    function buildArchetype(concerns, profile, tone){
      const s = id => (concerns.find(c=>c.id===id)||{}).score ?? 70;
      const A = knowledge.archetype;
      const barrier = s('oiliness')<55 ? A.barrier.oily : s('hydration')<58 ? A.barrier.dry : A.barrier.balanced;
      const react   = (s('redness')<58 || profile.sensitive==='Yes') ? A.reactivity.reactive : A.reactivity.resilient;
      const toneAx  = (s('uniformity')<62 || s('pigmentation')<62) ? A.tone.uneven : A.tone.even;
      const name = `${barrier} · ${react} · ${toneAx}`;
      // pick the most actionable blurb (worst axis)
      const cand = [[barrier,s('oiliness')<55?s('oiliness'):s('hydration')],[toneAx,Math.min(s('uniformity'),s('pigmentation'))],[react,s('redness')]].sort((a,b)=>a[1]-b[1]);
      return { name, blurb: A.blurbs[cand[0][0]] || A.blurbs[barrier] };
    }
  }
  return { analyze };
}
const sleep = ms => new Promise(r=>setTimeout(r,ms));


/* ===== landing.js ===== */
/* ============================================================
   landing.js — the marketing page below the hero.
   Everything here is progressive enhancement: if GSAP fails to load, or the visitor
   asks for reduced motion, every element is simply shown in its final state. Nothing
   on this page is ever hidden behind an animation that might not run.

   No cart code lives here on purpose — buying stays with Dawn's own product form.
   ============================================================ */


/* ui.js already owns `esc`; the Shopify build flattens all modules into one scope. */
const escL = s => String(s == null ? '' : s).replace(/[&<>"]/g, m => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[m]));

/* Resolve an image this file loads from JS (the particle plate, the proof plate).
   Standalone: it sits under the local img folder. Shopify: /assets/ is a FLAT, CDN-hosted
   directory with version-stamped URLs, so a relative path 404s — and that failure is silent
   and total (blank canvas, no metrics, empty console). The Liquid section publishes the real
   asset_url values on window.SI_ASSETS; this falls back to the local path when absent. */
const asset = name => (window.SI_ASSETS && window.SI_ASSETS[name]) || ('assets/img/' + name);
const FACE_PLATE = 'si-face-alpha.png';
const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* The face regions live in webgl-face.js — imported above, never re-declared here.
   Two copies is how they drifted apart before, and a flattened Shopify bundle turns a
   second `const REGIONS` into a fatal redeclaration that kills the whole app. */

function initLanding(concerns, products) {
  installLedger();                       // count every outbound byte from here on
  const list = (concerns && concerns.concerns) || [];

  buildFaceMap(list);
  buildKits(products);
  wireRoutineToggle();
  liveProof();

  /* Decide WebGL-vs-flat BEFORE any early return. Doing this inside the GSAP guard meant
     that under reduced-motion we bailed out first and never flipped the section to
     .is-flat — leaving a live <canvas> that renders nothing. A blank canvas is the exact
     failure a reduced-motion visitor must never see. */
  const sec = document.getElementById('siScan');
  const field = createFaceField({
    canvas: document.getElementById('siScanGL'),
    src: asset(FACE_PLATE),
    mobileZ: 300,                    // frame the WHOLE plate inside its bounded lower band
    phoneSize: 2.6,                  // close camera → fine points so the face reads as dots, not a white mass
    onReady: () => sec && sec.classList.add('is-gl'),
  });
  window.SI_FIELD = field;
  if (sec && !field) sec.classList.add('is-flat');   // no WebGL / reduced motion → the DOM face map
  if (list.length) showSignal(0);                    // never leave the map in a blank state

  const gsap = window.gsap;
  const ST = window.ScrollTrigger;
  if (!gsap || !ST || reduced()) { revealEverything(); return; }
  gsap.registerPlugin(ST);

  splitHeadings(gsap, ST);
  revealBlocks(gsap, ST);
  theScan(gsap, ST);
  theEnding(gsap, ST);
  countUp(gsap, ST);
  magnetic();

  /* ScrollTrigger caches each trigger's scroll position at creation time. The product and
     face images are still loading at that point, so the layout grows underneath it and the
     cached positions go stale — triggers then fire at the wrong place, or never fire, which
     leaves a HEADING PERMANENTLY INVISIBLE. Re-measure whenever the page height changes. */
  const refresh = () => { try { ST.refresh(); } catch (e) {} };
  window.addEventListener('load', refresh);
  document.querySelectorAll('.si-sec img').forEach(img => {
    if (!img.complete) img.addEventListener('load', refresh, { once: true });
  });
  if ('ResizeObserver' in window) {
    let t = null;
    new ResizeObserver(() => { clearTimeout(t); t = setTimeout(refresh, 120); }).observe(document.body);
  }

  /* Last-resort net: nothing on this page may stay invisible. If anything that should have
     revealed is still transparent once it is inside (or above) the viewport, just show it —
     losing an animation is always better than losing the content. */
  setInterval(() => {
    document.querySelectorAll('.si-rise, .si-word').forEach(el => {
      const b = el.getBoundingClientRect();
      if (b.top > window.innerHeight * 0.98) return;              // not reached yet — leave it alone
      const transparent = parseFloat(getComputedStyle(el).opacity) < 0.01;
      // a .si-word can also be pushed out of its overflow:hidden wrapper — visible opacity,
      // zero rendered height. Both count as "the user cannot read this".
      const clipped = el.classList.contains('si-word') && el.parentElement &&
                      b.bottom <= el.parentElement.getBoundingClientRect().top + 1;
      if (transparent || clipped) gsap.set(el, { opacity: 1, y: 0, yPercent: 0 });
    });
  }, 1200);

  // The page lives inside a single-screen app; when the user leaves and comes back the
  // layout has changed underneath ScrollTrigger, so let app.js ask us to re-measure.
  window.SI_REFRESH_SCROLL = refresh;
}

/* If motion is off (or GSAP never arrived) nothing may stay invisible. */
function revealEverything() {
  document.querySelectorAll('.si-rise, .si-word, [data-stagger] > *, .scan__phase, .scan__cap')
    .forEach(el => { el.style.opacity = '1'; el.style.transform = 'none'; });
  const sec = document.getElementById('siScan');
  if (sec) sec.classList.add('is-signals');     // the signal list must be usable
  const rail = document.getElementById('siScanRail');
  if (rail) rail.style.transform = 'scaleY(1)';
}

/* ---------------- 1. the ten signals, as an interactive face map ----------------
   The list is generated from the analyser's own concern data — labels, the "what we
   scanned for" line, AND the face regions. Hovering a signal lights up exactly the
   regions that concern is actually read from. */
let showSignal = () => {};

function buildFaceMap(list) {
  const ul = document.getElementById('siSignals');
  const face = document.getElementById('siFace');
  if (!ul || !list.length) return;

  ul.innerHTML = list.map((c, i) =>
    '<li class="si-sig" data-i="' + i + '" tabindex="0" role="button" aria-label="' + escL(c.label) + '">' +
      '<span class="si-sig__n">' + String(i + 1).padStart(2, '0') + '</span>' +
      '<span class="si-sig__t">' + escL(c.label) + '</span>' +
      '<span class="si-sig__bar"></span>' +
    '</li>'
  ).join('');

  if (!face) return;
  // one absolutely-positioned box per region, sized in % of the plate
  face.innerHTML = Object.keys(REGIONS).map(k => {
    const r = REGIONS[k];
    return '<span class="si-rg" data-rg="' + k + '" style="left:' + r.l + '%;top:' + r.t + '%;width:' + r.w + '%;height:' + r.h + '%"></span>';
  }).join('');

  const caps = document.getElementById('siMapCap');
  const boxes = face.querySelectorAll('.si-rg');
  const items = ul.querySelectorAll('.si-sig');

  const show = i => {
    const c = list[i];
    if (!c) return;
    items.forEach((el, j) => el.classList.toggle('on', j === i));
    const active = c.regions || [];
    boxes.forEach(b => b.classList.toggle('on', active.indexOf(b.dataset.rg) > -1));
    // same regions, lit on the GPU particle face
    if (window.SI_FIELD) window.SI_FIELD.setRegions(active);
    if (caps) {
      caps.innerHTML = '<b>' + escL(c.label) + '</b><span>' + escL(c.saw) + '</span>';
      caps.classList.add('on');
    }
  };

  let idx = 0, timer = null;
  const cycle = () => { show(idx); idx = (idx + 1) % list.length; };
  const start = () => { if (!timer && !reduced()) timer = setInterval(cycle, 2200); };
  const stop  = () => { clearInterval(timer); timer = null; };

  items.forEach((el, i) => {
    const pick = () => { stop(); show(i); };
    el.addEventListener('mouseenter', pick);
    el.addEventListener('focus', pick);
    el.addEventListener('click', pick);
  });
  ul.addEventListener('mouseleave', start);

  showSignal = show;
  show(0);
  idx = 1;
  // only auto-cycle while the section is actually on screen
  if ('IntersectionObserver' in window) {
    const sec = ul.closest('.scan');
    new IntersectionObserver(es => {
      es.forEach(e => (e.isIntersecting ? start() : stop()));
    }, { threshold: 0.25 }).observe(sec || ul);
  } else start();
}

/* ---------------- 2. the kits ----------------
   The four real Siora kits, straight from the catalogue. Plain links to the product pages —
   no cart code here on purpose: buying stays with Dawn's own product form. */
function buildKits(products) {
  const strip = document.getElementById('siKits');
  const kits = (products && products.kits) || [];
  if (!strip || !kits.length) return;
  const sym = (products && products.currencySymbol) || '';
  // the teaser shows a diverse FOUR (acne / brightening / hydration / glow); the analyzer
  // matches the full combo range to the visitor's own scan.
  const TEASER = ['combo-acne-control','combo-brightening','combo-hydration','combo-glass-skin'];
  const picked = TEASER.map(id => kits.find(k => k.id === id)).filter(Boolean);
  const show = picked.length === 4 ? picked : kits.slice(0, 4);
  strip.innerHTML = show.map(k =>
    '<li class="kit si-rise">' +
      '<a href="' + escL(k.url) + '">' +
        '<span class="kit__img">' + (k.image ? '<img src="' + escL(k.image) + '" alt="' + escL(k.title) + '" loading="lazy" decoding="async" width="400" height="400">' : '') + '</span>' +
        '<span class="kit__body">' +
          '<span class="kit__t">' + escL(k.title) + '</span>' +
          '<span class="kit__s">' + escL(k.subtitle || '') + '</span>' +
          '<span class="kit__p">' +
            '<b>' + sym + escL(k.price) + '</b>' +
            (k.compareAt ? '<s>' + sym + escL(k.compareAt) + '</s>' : '') +
          '</span>' +
        '</span>' +
      '</a>' +
    '</li>'
  ).join('');
}

/* ---------------- 2b. THE PROOF — privacy, demonstrated ----------------
   Runs the analyser's own maths on a face in the visitor's browser, stages the results
   like an instrument, and prints how many network requests it made doing it (zero).
   Fires only when the section is actually reached, so the numbers appear as you arrive. */
const PROOF_ZONES = [        // each metric, read from the analyser's own region
  REGIONS.cheekLeft,         // redness     → cheeks
  REGIONS.forehead,          // shine       → T-zone
  REGIONS.cheekRight,        // texture     → cheeks
  REGIONS.underEyeLeft,      // under-eye Δ
  REGIONS.noseBridge,        // tone        → nose bridge / mid-face
];

function liveProof() {
  const sec = document.getElementById('siProof');
  const rows = document.getElementById('siProofRows');
  if (!sec || !rows) return;

  const zones = sec.querySelectorAll('.proof__zone');
  zones.forEach((z, i) => {
    const r = PROOF_ZONES[i]; if (!r) return;
    z.style.cssText = 'left:' + r.l + '%;top:' + r.t + '%;width:' + r.w + '%;height:' + r.h + '%';
  });

  const num = (el, to, dp, unit) => {
    const from = 0, DUR = 700, t0 = performance.now();
    const tick = now => {
      const p = Math.min(1, (now - t0) / DUR);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = (from + (to - from) * e).toFixed(dp) + unit;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  let started = false;
  const start = () => {
    if (started) return;
    started = true;

    runLiveProof({
      src: asset(FACE_PLATE),
      onDone: res => {
        if (!res) { sec.style.display = 'none'; return; }   // never show a broken instrument

        rows.innerHTML = res.metrics.map(m =>
          '<li class="proof__row">' +
            '<span class="proof__k">' + escL(m.k) + '</span>' +
            '<span class="proof__sub">' + escL(m.sub) + '</span>' +
            '<span class="proof__v">0</span>' +
          '</li>').join('');

        const items = rows.querySelectorAll('.proof__row');
        res.metrics.forEach((m, i) => {
          setTimeout(() => {
            items[i].classList.add('in');
            zones.forEach((z, j) => z.classList.toggle('on', j === i));
            num(items[i].querySelector('.proof__v'), m.v, m.dp, m.unit);
          }, 260 + i * 320);
        });

        // the footer — and the two numbers this whole section exists to print
        setTimeout(() => {
          zones.forEach(z => z.classList.remove('on'));
          const px = document.getElementById('siProofPx');
          const ms = document.getElementById('siProofMs');
          // count up, but keep the thousands separator (a plain num() tween stomped it)
          const t0 = performance.now();
          const tick = now => {
            const p = Math.min(1, (now - t0) / 800);
            const e = 1 - Math.pow(1 - p, 3);
            px.textContent = Math.round(res.pixelsRead * e).toLocaleString();
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          num(ms, res.ms, 0, '');
          /* What the ANALYSIS sent — scoped to the computation, not the whole page. A live
             storefront also runs Shopify analytics + a Meta pixel, whose beacons would make a
             page-wide tally read 15/9,465 and turn this section's whole claim into a lie. The
             analysis is synchronous and sends nothing, so these are a true, checkable zero. */
          document.getElementById('siProofReq').textContent = res.reqDuringAnalysis;
          document.getElementById('siProofBytes').textContent = res.bytesDuringAnalysis;
          sec.querySelectorAll('.proof__zero').forEach(z => z.classList.add('is-zero'));
        }, 260 + res.metrics.length * 320);
      },
    });
  };

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(e => e.isIntersecting && start()), { threshold: 0.2 }).observe(sec);
  } else start();

  /* If they actually take the dare and pull the plug, say so. */
  const on = sec.querySelector('[data-online]'), off = sec.querySelector('[data-offline]');
  const netState = () => {
    const offline = navigator.onLine === false;
    if (on) on.hidden = offline;
    if (off) off.hidden = !offline;
  };
  window.addEventListener('online', netState);
  window.addEventListener('offline', netState);
  netState();
}

/* ---------------- 3. morning / evening ----------------
   The whole section crosses from daylight ivory to night — the one big flourish. */
function wireRoutineToggle() {
  const sec = document.querySelector('.si-when');
  if (!sec) return;
  const tabs = sec.querySelectorAll('[data-when]');
  const panes = sec.querySelectorAll('.si-when__pane');
  tabs.forEach(btn => btn.addEventListener('click', () => {
    const when = btn.dataset.when;
    tabs.forEach(b => b.setAttribute('aria-selected', String(b === btn)));
    panes.forEach(p => p.classList.toggle('on', p.dataset.pane === when));
    sec.classList.toggle('is-pm', when === 'pm');
  }));
}

/* FAQ needs no JS at all now: native <details name="siora-faq"> gives exclusive-open,
   keyboard, screen readers and find-in-page for free. The old handler called
   preventDefault() on <summary>, which broke every one of those. */

/* ---------------- 5. headings reveal word by word ---------------- */
function splitHeadings(gsap, ST) {
  document.querySelectorAll('[data-split]').forEach(h => {
    // keep <br> as line breaks; wrap every word so it can be staggered
    const html = h.innerHTML.split(/<br\s*\/?>/i).map(line =>
      line.trim().split(/\s+/).filter(Boolean)
        .map(w => '<span class="si-word__w"><span class="si-word">' + w + '</span></span>').join(' ')
    ).join('<br>');
    h.innerHTML = html;
    const words = h.querySelectorAll('.si-word');
    /* Normalise the start state through GSAP. The CSS sets translateY(105%), but GSAP reads
       the computed matrix and records that as a PIXEL y-offset with yPercent:0 — so animating
       yPercent to 0 changed nothing and every word stayed pushed out of its overflow:hidden
       wrapper at full opacity: invisible, yet not transparent. */
    gsap.set(words, { yPercent: 105, y: 0, opacity: 0 });
    gsap.to(words, {
      yPercent: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.045,
      scrollTrigger: { trigger: h, start: 'top 88%', once: true },
    });
  });
}

/* ---------------- 6. generic block reveals ---------------- */
function revealBlocks(gsap, ST) {
  gsap.utils.toArray('.si-rise').forEach(el => {
    gsap.to(el, {
      y: 0, opacity: 1, duration: 0.9, ease: 'expo.out',
      scrollTrigger: { trigger: el, start: 'top 90%', once: true },
    });
  });
  gsap.utils.toArray('[data-stagger]').forEach(group => {
    gsap.to(group.children, {
      y: 0, opacity: 1, duration: 0.85, ease: 'expo.out', stagger: 0.09,
      scrollTrigger: { trigger: group, start: 'top 86%', once: true },
    });
  });
}

/* ---------------- 7. THE SCAN — the WebGL narrative ----------------
   One 420vh section, one sticky viewport, one scroll timeline:
     0.00 – 0.30  the dust assembles into her face
     0.30 – 0.58  a scan plane sweeps down it
     0.58 – 1.00  the ten signals appear; each lights up the regions it is read from
   The particle field is a bonus — if WebGL is missing we flip the section to .is-flat and
   the plain face map (already in the DOM) drives the exact same interaction. */
function theScan(gsap, ST) {
  const sec = document.getElementById('siScan');
  if (!sec) return;
  const phases = sec.querySelectorAll('.scan__phase');
  const rail = document.getElementById('siScanRail');

  const field = window.SI_FIELD;                   // already created in initLanding

  let phase = -1;
  const setPhase = i => {
    if (i === phase) return;
    phase = i;
    phases.forEach((p, j) => p.classList.toggle('is-on', j === i));
    sec.classList.toggle('is-signals', i === 2);
  };
  setPhase(0);

  ST.create({
    trigger: sec,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 1,          // a NUMBER, not true — adds smoothing and hides scroll jitter
    onUpdate: self => {
      const t = self.progress;

      if (field) {
        field.setOpacity(t < 0.02 ? 0 : 1);
        field.setProgress(Math.min(1, t / 0.28));                 // dust → face
        field.setScan(t > 0.3 && t < 0.6 ? (t - 0.3) / 0.3 : null); // the sweep
      }

      if (t < 0.3) setPhase(0);
      else if (t < 0.58) setPhase(1);
      else setPhase(2);

      if (rail) gsap.set(rail, { scaleY: t });
    },
  });

  // cursor parallax on the point cloud
  if (field) {
    sec.addEventListener('mousemove', e => {
      const r = sec.getBoundingClientRect();
      field.setTilt(((e.clientX - r.left) / r.width - 0.5) * 2, ((e.clientY - r.top) / r.height - 0.5) * 2);
    });
    // don't burn GPU when the section is off screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => (e.isIntersecting ? field.resume() : field.pause())),
        { threshold: 0.01 }).observe(sec);
    }
  }
}

/* ---------------- 7b. THE CLOSING — the face becomes the words ----------------
   A second particle field, seeded from the same photo. The whole animation is contained in
   one 100svh block: it starts as her face and is fully the headline by the moment that
   block fills the screen. Then it dissolves as the block scrolls off, so the words are
   never seen sliding up under the fixed header — and what you scroll into is the CTA,
   which is a full-height section of its own. */
function theEnding(gsap, ST) {
  const sec = document.getElementById('siEnd');
  const canvas = document.getElementById('siEndGL');
  if (!sec || !canvas) return;

  const field = createFaceField({
    canvas,
    src: asset(FACE_PLATE),
    mobileZ: 560,                    // keep the closing's text-sized framing on phones
    onReady: () => {
      sec.classList.add('is-gl');
      const h = document.getElementById('siEndH');
      const words = (h ? h.textContent : 'See your skin.').trim().replace(/\.$/, '').split(' ');
      const lines = words.length > 2 ? [words.slice(0, 2).join(' '), words.slice(2).join(' ')] : [words.join(' ')];
      // lift the words into the upper-middle so the CTA can sit just beneath them in the
      // same viewport (oy is world-Y, +up). On a narrow phone the headline is sized down and
      // narrowed so "SEE YOUR / SKIN" never runs off the sides.
      const mob = window.innerWidth < 760;
      field.setTextTarget(lines.map(l => l.toUpperCase()),
        mob ? { size: 126, width: 176, oy: 40 } : { size: 168, width: 322, oy: 40 });
      field.setProgress(1);       // already assembled — she is the face you just scanned
      field.setOpacity(1);
    },
  });
  if (!field) return;             // no WebGL → the real <h2> is already visible

  const morph = document.getElementById('siEndMorph') || sec;

  /* The morph is TIMED, not scrubbed. It is the page's last line, and a line should be
     delivered at its own pace — not at whatever speed the visitor happens to spin the wheel.
     So: she arrives as the face you just scanned, holds a beat, becomes the words, and holds
     again — the whole arc starting and finishing while this 100svh block is the viewport. */
  const m = { v: 0 };
  const tl = gsap.timeline({ paused: true })
    .to(m, {
      v: 1, duration: 2.2, ease: 'power2.inOut', delay: 0.45,
      onUpdate: () => field.setMorph(m.v),
    })
    .to({}, { duration: 1.0 });          // let the words stand before the CTA is asked for

  ST.create({
    trigger: morph,
    start: 'top 70%',                    // the block is a third in — the visitor is here
    onEnter: () => { field.setOpacity(1); tl.play(); },
    onLeaveBack: () => {                 // scrolled back above it: rewind so it plays again
      tl.pause(0);
      m.v = 0;
      field.setMorph(0);
      field.setOpacity(1);
    },
  });

  sec.addEventListener('mousemove', e => {
    const r = sec.getBoundingClientRect();
    field.setTilt(((e.clientX - r.left) / r.width - 0.5) * 1.4, ((e.clientY - r.top) / r.height - 0.5) * 1.0);
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(e => (e.isIntersecting ? field.resume() : field.pause())),
      { threshold: 0.01 }).observe(morph);   // idle while the CTA block owns the viewport
  }
}


/* ---------------- 8. numbers count up when they scroll in ---------------- */
function countUp(gsap, ST) {
  document.querySelectorAll('[data-count]').forEach(el => {
    const m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    const target = parseInt(m[1], 10), suffix = m[2] || '';
    const o = { v: 0 };
    gsap.to(o, {
      v: target, duration: 1.4, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 92%', once: true },
      onUpdate: () => { el.textContent = Math.round(o.v) + suffix; },
    });
  });
}

/* ---------------- 9. the closing button leans toward the cursor ---------------- */
function magnetic() {
  document.querySelectorAll('[data-magnetic]').forEach(btn => {
    const R = 90;
    const move = e => {
      const b = btn.getBoundingClientRect();
      const dx = e.clientX - (b.left + b.width / 2);
      const dy = e.clientY - (b.top + b.height / 2);
      const d = Math.hypot(dx, dy);
      if (d < R + Math.max(b.width, b.height) / 2) {
        btn.style.transform = 'translate(' + dx * 0.22 + 'px,' + dy * 0.28 + 'px)';
      } else btn.style.transform = '';
    };
    const reset = () => { btn.style.transform = ''; };
    window.addEventListener('mousemove', move, { passive: true });
    btn.addEventListener('mouseleave', reset);
  });
}


/* ===== app.js ===== */
/* ============================================================
   app.js — state machine + wiring for Siora SkinInsights.
   ============================================================ */

const SCREENS = ['landing','consent','instructions','capture','questionnaire','lead','processing','results','routine'];
const $ = s => document.querySelector(s);
const store = { profile:{}, capture:null, result:null, routine:null, cart:[], scanId:null };

let products, concerns, knowledge, engine, routineEngine, capture, questionnaire, currentScreen='landing', config;

const CONFIG_DEFAULTS = {
  aiMode:'demo', aiEndpoint:'', leadMode:'', leadEndpoint:'', leadEmailDetails:true, flywheelEndpoint:'',
  brandName:'', heroEyebrow:'', heroHeading:'', heroSubtext:'', heroNote:'', ctaText:'',
  requireEmail:true, collectPhone:true, leadHeading:'',
  showAge:true, showSafety:true, showArchetype:true, showRadar:true,
  cartMode:'demo', disclaimerText:'', accent:'#1f9d61', privacyUrl:'', debug:false
};

function applyConfig(raw){
  const c = { ...CONFIG_DEFAULTS, ...raw };
  const set=(sel,val,html)=>{ const el=$(sel); if(el&&val){ html?el.innerHTML=val:el.textContent=val; } };
  set('.si-brand', c.brandName);
  set('[data-screen="landing"] .si-pill__t', c.heroEyebrow);
  set('[data-screen="landing"] .si-lede', c.heroSubtext);
  set('.si-cta', c.ctaText ? (c.ctaText) : '');
  // small print under the CTA — an empty setting hides it entirely
  const note = $('.si-hero__note');
  if(note && 'heroNote' in (raw || {})){
    if(c.heroNote){ note.textContent = c.heroNote; } else { note.style.display = 'none'; }
  }
  /* The hero headline is animated word-by-word, so it can't be set as plain text —
     that would strip the .si-w spans. Rebuild them. "|" (or a newline) = a line break. */
  const h1 = $('[data-screen="landing"] .si-h1');
  if (h1 && c.heroHeading){
    const lines = String(c.heroHeading).split(/\||\n/).map(s=>s.trim()).filter(Boolean);
    const e = t => String(t).replace(/[&<>"]/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
    h1.innerHTML = lines.map((t,i)=>
      `<span class="si-w${i===lines.length-1 && lines.length>1 ? ' si-w--fill':''}">${e(t)}</span>`
    ).join(' ');
  }
  if(c.leadHeading) set('[data-screen="lead"] .si-h2', c.leadHeading);
  if(!c.collectPhone){ const ph=document.querySelector('#siLeadForm [name="phone"]'); if(ph) ph.closest('.si-field').style.display='none'; }
  if(c.privacyUrl){ const pl=$('#siPrivacyLink'); if(pl) pl.href=c.privacyUrl; }
  // Honest consent: only offer the anonymized data opt-in if there's actually somewhere to store it.
  if(!c.flywheelEndpoint && !c.leadEndpoint){ const fw=$('#siFlywheel'); if(fw){ const row=fw.closest('.si-check'); if(row) row.style.display='none'; fw.checked=false; } }
  document.documentElement.style.setProperty('--accent', c.accent);
  return c;
}

/* Hero stat numbers count up once, in step with the CSS reveal.
   The value is read from the element's own text, so whatever the merchant types works:
   "10" and "60s" and "95%" count up (keeping any suffix); "AM + PM" is left alone. */
function heroCounters(){
  const els = document.querySelectorAll('.si-hero__stats b');
  if(!els.length) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  els.forEach((el, i) => {
    const m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if(!m) return;                                   // not numeric — show as typed
    const target = parseInt(m[1], 10);
    const suffix = m[2] || '';
    if(!isFinite(target)) return;
    const from = Math.max(0, target - Math.min(target, 12));
    const DUR = 900, delay = 1150 + i * 150;
    let start = null;
    const tick = now => {
      if(start === null) start = now;
      const p = Math.min(1, (now - start) / DUR);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(from + (target - from) * eased) + suffix;
      if(p < 1) requestAnimationFrame(tick);
    };
    el.textContent = from + suffix;
    setTimeout(() => requestAnimationFrame(tick), delay);
  });
}

/* NB: ui.js already declares `esc`. The Shopify build flattens every module into ONE
   scope, so a second `const esc` there is a fatal redeclaration — hence the distinct name. */
/* Hero video — loops forever.
   The clip is a palindrome (the reveal played forward, then reversed), cut to start AFTER
   the source's fade-up from white. So its last frame equals its first: `loop` joins
   seamlessly, with no white flash and no cross-dissolve ghosting between poses. */
function heroVideo(){
  const v = document.getElementById('siHeroVideo');
  if(!v) return;
  const scan = v.closest('.si-scan');

  // Hard failure (bad codec, or a browser refusing the CDN's Content-Type — Shopify serves
  // theme-asset video as application/mp4 + nosniff): show the settled still instead, so the
  // hero still reads correctly rather than sitting blank.
  const useStill = () => { if(scan) scan.classList.add('is-still'); };
  v.addEventListener('error', useStill);
  v.addEventListener('stalled', () => { if(v.readyState === 0) useStill(); });
  setTimeout(() => { if(v.readyState === 0) useStill(); }, 6000);   // never loaded a frame

  // No motion wanted: drop the video entirely and show the settled frame.
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    v.removeAttribute('autoplay');
    v.removeAttribute('loop');
    v.pause();
    useStill();
    return;
  }

  /* First-load autoplay: calling play() once, immediately, is why the hero only ran on the
     SECOND (cached) load — on a cold load the file isn't buffered yet, play() rejects with a
     transient "not ready", and we used to fall straight to the still. Instead we retry play()
     on every event that fires once a frame is actually decodable, and swallow the transient
     rejection. The genuine-failure paths (error event, 6s with readyState 0) still show the
     still, and muted+playsinline means a real autoplay refusal is virtually impossible. */
  let playing = false;
  const play = () => {
    if(playing) return;
    const p = v.play();
    if(p && p.then) p.then(() => { playing = true; }).catch(() => {});   // transient → retry on next ready event
  };
  ['loadeddata','loadedmetadata','canplay','canplaythrough','playing'].forEach(ev =>
    v.addEventListener(ev, play));
  v.addEventListener('pause', () => { playing = false; });   // so the observer can resume it
  if(v.readyState >= 2) play();    // already decodable (cached) — go now
  else play();                      // kick a load; the ready events above will retry

  if('IntersectionObserver' in window){
    new IntersectionObserver(entries => {
      entries.forEach(e => { if(e.isIntersecting) play(); else v.pause(); });  // don't decode off-screen
    }, { threshold: 0.15 }).observe(v);
  }
  // Only ever RESUME on tab-return; the observer handles off-screen pausing.
  document.addEventListener('visibilitychange', () => {
    if(!document.hidden && currentScreen === 'landing') play();
  });
}

init();

async function init(){
  try{
    // On Shopify the data is inlined as globals (window.SI_*); standalone loads JSON files.
    if(window.SI_PRODUCTS && window.SI_CONCERNS && window.SI_KNOWLEDGE){
      products=window.SI_PRODUCTS; concerns=window.SI_CONCERNS; knowledge=window.SI_KNOWLEDGE;
    } else {
      products = window.SI_PRODUCTS; concerns = window.SI_CONCERNS; knowledge = window.SI_KNOWLEDGE;
    }
  }catch(err){
    console.error('[siora] failed to load data', err);
    const main=document.querySelector('.si-main')||document.body;
    main.innerHTML='<div style="padding:48px 22px;text-align:center;max-width:34ch;margin:0 auto;font-family:Poppins,sans-serif">'+
      '<p style="font-size:32px;margin-bottom:10px">😕</p><h2 style="font-family:Assistant,sans-serif;font-size:20.8px;margin-bottom:8px">Couldn’t start the analyzer</h2>'+
      '<p style="color:#666;font-size:15.2px">Please check your connection and reload the page.</p>'+
      '<button onclick="location.reload()" style="margin-top:18px;padding:12px 24px;background:#121212;color:#fff;border:0;font-family:Assistant,sans-serif;cursor:pointer">Reload</button></div>';
    return;
  }
  config = applyConfig(window.SI_CONFIG||{});
  engine = createAnalysisEngine(concerns, knowledge, products, config);
  routineEngine = createRoutineEngine(products, knowledge);

  heroCounters();
  heroVideo();
  initLanding(concerns, products);

  // generic navigation buttons
  document.querySelectorAll('[data-go]').forEach(b=>b.addEventListener('click',()=>go(b.dataset.go)));

  // consent gate
  $('#siConsent').addEventListener('change',e=>{ $('#siConsentNext').disabled=!e.target.checked; });

  // back button
  $('#siBack').addEventListener('click',onBack);

  // camera controller
  capture = createCapture({
    video:$('#siVideo'), overlay:$('#siOverlay'), ring:$('#siRing'), hint:$('#siHint'),
    checks:$('#siChecks'), count:$('#siCount'), shutter:$('#siShutter'), retake:$('#siRetake'), auto:$('#siAuto')
  }, onCaptured);

  // photo-upload fallback (no camera / desktop / permission denied)
  const upBtn=$('#siUploadBtn'), upIn=$('#siUploadInput');
  if(upBtn && upIn){
    upBtn.addEventListener('click',()=>{ track('upload_click'); upIn.click(); });
    upIn.addEventListener('change',e=>{ const f=e.target.files&&e.target.files[0]; if(f){ store.captureSource='upload'; capture.fromFile(f); } e.target.value=''; });
  }

  // lead form
  $('#siLeadForm').addEventListener('submit',onLead);

  // --- dev test hook (only with ?test=1): drives the real pipeline without a camera ---
  if(new URLSearchParams(location.search).has('test')){
    window.__siora = { go, store, products, concerns,
      fakeCapture(){
        const c=document.createElement('canvas'); c.width=360; c.height=480; const x=c.getContext('2d');
        const g=x.createLinearGradient(0,0,0,480); g.addColorStop(0,'#ecc6aa'); g.addColorStop(1,'#d7a484'); x.fillStyle=g; x.fillRect(0,0,360,480);
        x.fillStyle='rgba(110,72,62,.45)'; x.fillRect(72,150,78,26); x.fillRect(210,150,78,26);            // under-eye
        x.fillStyle='rgba(205,95,82,.4)'; [[110,265,20],[250,255,16],[180,330,14]].forEach(([a,b,r])=>{x.beginPath();x.arc(a,b,r,0,7);x.fill();}); // redness/blemish
        x.fillStyle='rgba(255,255,255,.5)'; x.fillRect(160,90,40,8);                                        // T-zone shine
        store.capture={ dataURL:c.toDataURL('image/jpeg',.9), imageData:x.getImageData(0,0,360,480), landmarks:null, faceBox:null };
        store.profile={ name:'Fahad', age:'25 to 30', gender:'Male', skinType:'Oily / Combination', sensitive:'Sometimes', email:'test@siora.pk' };
        go('processing');
      }
    };
  }
}

/* ---------------- screen router ---------------- */
function go(name){
  const prev=currentScreen;
  currentScreen=name;
  document.querySelectorAll('.si-screen').forEach(s=>s.classList.toggle('is-active', s.dataset.screen===name));
  /* The hero is full-width; every other screen stays in the narrow reading column. Widening
     .si-app is what lets the hero span the page WITHOUT a `width:100vw` bleed hack — 100vw
     counts the scrollbar, so that hack overflowed to the right on any machine that shows one. */
  const app = document.getElementById('siApp');
  if(app) app.classList.toggle('is-landing', name === 'landing');
  // the landing screen was display:none — ScrollTrigger's cached positions are now stale
  if(name === 'landing' && typeof window.SI_REFRESH_SCROLL === 'function') setTimeout(window.SI_REFRESH_SCROLL, 60);
  window.scrollTo(0,0);
  if(name!==prev) track('screen', { screen:name, from:prev });   // funnel step view
  if(name==='consent' && prev==='landing') track('start');       // user began the analysis
  // progress + back
  const idx=SCREENS.indexOf(name);
  const pct=Math.round((idx/(SCREENS.length-1))*100);
  const prog=$('#siProgress'); prog.firstElementChild.style.width = pct+'%'; prog.setAttribute('aria-valuenow', pct);
  $('#siBack').classList.toggle('show', idx>0 && name!=='processing' && name!=='results' && name!=='routine');
  prog.style.visibility = (name==='processing') ? 'hidden':'visible';

  // a11y: move focus to the new screen's heading so screen readers announce it
  const active=document.querySelector('.si-screen.is-active');
  const h=active && active.querySelector('.si-h1, .si-h2, h1, h2');
  if(h){ h.setAttribute('tabindex','-1'); try{ h.focus({preventScroll:true}); }catch(e){ h.focus(); } }

  // per-screen enter hooks
  if(name==='capture') capture.start();
  else capture.stop();
  if(name==='questionnaire') startQuestionnaire();
  if(name==='processing') runAnalysis();
}

function onBack(){
  const order=['landing','consent','instructions','capture','questionnaire','lead'];
  if(currentScreen==='questionnaire' && questionnaire){ questionnaire.back(); return; }
  const i=order.indexOf(currentScreen);
  if(i>0) go(order[i-1]);
}

/* ---------------- capture ---------------- */
function onCaptured(cap){
  store.capture=cap;
  track('photo_captured', { source: store.captureSource||'camera', hasFace: !!(cap && cap.faceBox), landmarks: !!(cap && cap.landmarks) });
  store.captureSource=null;
  go('questionnaire');
}

/* ---------------- questionnaire ---------------- */
function startQuestionnaire(){
  questionnaire = createQuestionnaire($('#siQ'),
    profile=>{ store.profile={...store.profile,...profile};
      if(config.requireEmail){ prefillLead(); go('lead'); } else { go('processing'); } },
    ()=>go('capture')
  );
}
function prefillLead(){ if(store.profile.name) $('#siLeadName').value=store.profile.name; }

/* ---------------- lead ---------------- */
function onLead(e){
  e.preventDefault();
  const f=e.target, email=f.email.value.trim();
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ f.email.classList.add('err'); f.email.focus(); return; }
  store.profile.email=email;
  store.profile.phone=f.phone.value.trim();
  store.profile.name = store.profile.name || f.name.value.trim();
  store.profile.optin = f.optin.checked;
  store.profile.contribute = !!($('#siFlywheel')||{}).checked;   // opt-in data flywheel

  // Persist the lead (email/phone/profile only — NEVER the raw image). Fire-and-forget:
  // funnel never stalls on the network. Route per merchant config.
  if(config.leadMode==='shopify'){
    // native: build the Shopify marketing list + (optionally) email the store the full detail
    shopifyLead(store.profile, { emailDetails: config.leadEmailDetails!==false, tags:'skin-insights,newsletter' })
      .catch(()=>{});
  } else if(config.leadEndpoint){
    postJSON(config.leadEndpoint, {
      type:'lead', source:'skin-insights',
      name: store.profile.name, email: store.profile.email, phone: store.profile.phone,
      optin: store.profile.optin,
      profile: { age: store.profile.age, gender: store.profile.gender, skinType: store.profile.skinType, sensitive: store.profile.sensitive },
      page: location.href
    });
  }
  track('lead', { has_phone: !!store.profile.phone, optin: store.profile.optin, mode: config.leadMode||'endpoint' });
  go('processing');
}

/* ---------------- processing → analyse ---------------- */
async function runAnalysis(){
  $('#siProcImg').src = store.capture.dataURL;
  const steps=$('#siProcSteps');
  const setStep=k=>{ steps.querySelectorAll('li').forEach(li=>{
    if(li.dataset.s===k) li.className='now';
    else if(isBefore(li.dataset.s,k)) li.className='done';
  }); };
  try{
    store.result = await engine.analyze({
      imageData: store.capture.imageData, dataURL: store.capture.dataURL,
      landmarks: store.capture.landmarks, profile: store.profile
    }, setStep);
    steps.querySelectorAll('li').forEach(li=>li.className='done');
    store.routine = routineEngine.build(store.result);
    await wait(450);
    paintResults();
    go('results');

    const r=store.result;
    track('results', { overall:r.overall, primary:r.primaryId, secondary:r.secondaryId, provider:r.provider, confidence:Math.round(r.confidence*100) });

    /* The visitor's OWN record: contact + their scan, stored together. This is what the
       consent screen promises ("only your skin scores and contact details, with your
       consent"), and it's the row that lands in the spreadsheet export. Only sent when they
       actually gave us contact details — never an image, in any branch. */
    if(config.leadEndpoint && (store.profile.email || store.profile.phone)){
      postJSON(config.leadEndpoint, {   // response carries the scan id, used to build the PDF
        type:'scan', source:'skin-insights',
        name: store.profile.name, email: store.profile.email, phone: store.profile.phone,
        optin: store.profile.optin,
        profile: { age: store.profile.age, gender: store.profile.gender, skinType: store.profile.skinType, sensitive: store.profile.sensitive },
        result: {
          overall: r.overall, perceivedSkinAge: r.perceivedSkinAge, ageDelta: r.ageDelta,
          primaryConcern: r.primaryConcern, secondaryConcern: r.secondaryConcern,
          provider: r.provider, confidence: r.confidence, retake: !!r.retake,
          mode: r.cvMetrics && r.cvMetrics.mode,
          skinTone: r.skinTone ? { monk:r.skinTone.monk, fitzpatrick:r.skinTone.fitzpatrick, ita:r.skinTone.ita } : null,
          concerns: r.concerns.map(c=>({ id:c.id, label:c.label, score:c.score, grade:c.grade }))
        },
        page: location.href
      }).then(res=>{ if(res && res.data && res.data.scan_id) store.scanId = res.data.scan_id; });
    }

    // Opt-in data flywheel — anonymized scores ONLY. No name, no email, no image.
    if(store.profile.contribute){
      postJSON(config.flywheelEndpoint || config.leadEndpoint, {
        type:'contribute', source:'skin-insights',
        scores: Object.fromEntries(r.concerns.map(c=>[c.id,c.score])),
        overall: r.overall, perceivedSkinAge: r.perceivedSkinAge,
        skinTone: r.skinTone ? { monk:r.skinTone.monk, fitzpatrick:r.skinTone.fitzpatrick, ita:r.skinTone.ita } : null,
        band: { age: store.profile.age, gender: store.profile.gender, skinType: store.profile.skinType, sensitive: store.profile.sensitive },
        quality: r.quality ? { retake:!!r.retake, mode:r.cvMetrics && r.cvMetrics.mode } : null,
        provider: r.provider
      });
    }
  }catch(err){
    console.error(err); toast('Analysis failed — please retake your photo.');
    track('error', { where:'analyze', message:String(err && err.message || err) });
    go('capture');
  }
}
const ORDER=['detect','measure','grade','routine'];
const isBefore=(a,b)=>ORDER.indexOf(a)<ORDER.indexOf(b);

/* ---------------- results + routine ---------------- */
function paintResults(){
  renderResults($('#siResults'), store.result, products.currencySymbol, config,
    ()=>{ paintRoutine(); go('routine'); },
    ()=>{
      track('download_report', { to: !!store.profile.email });
      downloadReport();
    }
  );
}
/* The backend renders the PDF from the scan row it already holds, so nothing about
   the visitor is re-uploaded here — we send an id and get back a signed link. */
async function downloadReport(){
  if(!config.leadEndpoint){ toast('Report delivery is not configured yet.'); return; }
  toast('Building your report…');
  const steps = ((store.routine && store.routine.am) || []).map(s=>({
    step: s.label, title: s.product && s.product.title, why: s.why
  })).filter(s=>s.title);

  const res = await postJSON(config.leadEndpoint, {
    type:'report', source:'skin-insights', scan_id: store.scanId || null,
    email: store.profile.email, phone: store.profile.phone, name: store.profile.name,
    optin: store.profile.optin, routine: steps, page: location.href
  });

  const url = res && res.data && res.data.url;
  if(!url){
    toast('Could not build the report — please try again.');
    track('error', { where:'report', message: (res && (res.error || res.status)) || 'no url' });
    return;
  }
  // Same-tab navigation is blocked by popup rules after an await, so use a link click.
  const a=document.createElement('a'); a.href=url; a.target='_blank'; a.rel='noopener';
  a.download='siora-skin-report.pdf'; document.body.appendChild(a); a.click(); a.remove();
  toast('Your report is ready.');
}

function paintRoutine(){
  renderRoutine($('#siRoutine'), store.routine, products.currencySymbol, knowledge, store.result,
    id=>addItems([id]),
    all=>addItems(all.map(p=>p.id), true),
    ()=>onViewCart()
  );
}
const itemById = id => (products.products||[]).find(x=>x.id===id) || (products.kits||[]).find(x=>x.id===id);

// Add one or many products, honouring the merchant's cart mode.
//  'shopify' → real AJAX cart (variant resolved from the handle) with graceful fallback
//  'pdp'     → open the product page(s)
//  'demo'    → in-app cart (local preview)
async function addItems(ids, isAll){
  const items = ids.map(itemById).filter(Boolean);
  if(!items.length) return;
  items.forEach(it=>{ if(!store.cart.includes(it.id)) store.cart.push(it.id); });
  const value = items.reduce((s,it)=>s+(it.price||0),0);
  track(isAll?'add_all':'add_to_cart', { ids, count:items.length, value, currency: products.currency||'PKR' });

  if(config.cartMode==='pdp'){
    if(isAll) window.open(items[0].url,'_blank','noopener'); else window.open(items[0].url,'_blank','noopener');
    return;
  }
  if(config.cartMode==='shopify'){
    try{
      const res = await shopifyAdd(items.map(it=>({ handle: handleOf(it.url), quantity:1 })));
      if(!res.uiHandled) toast(isAll?`Added ${items.length} products to cart`:`${items[0].title} added to cart`);
      return;
    }catch(err){
      console.warn('[cart] AJAX add failed → opening product page', err.message);
      track('error', { where:'cart', message:String(err && err.message || err) });
      window.open(items[0].url,'_blank','noopener');   // never leave the shopper stuck
      return;
    }
  }
  // demo
  toast(isAll?`Added ${items.length} products to cart`:`${items[0].title} added to cart`);
}
function onViewCart(){
  track('view_cart');
  if(config.cartMode==='shopify'){ window.location.href='/cart'; return; }
  if(config.cartMode==='pdp'){ window.open('https://siora.pk/cart','_blank','noopener'); return; }
  toast('Cart preview — wired to your Shopify cart on launch.');
}




})();
